import { connect } from "react-redux";
import React, { useState, useEffect, memo, useCallback } from "react";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import moment from "moment";
import ReactModal from "react-modal";
import Alert from "react-s-alert";
import axios from "axios";
import get from "lodash/get";
import map from "lodash/map";
import head from "lodash/head";
import find from "lodash/find";
import split from "lodash/split";
import last from "lodash/last";
import replace from "lodash/replace";
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";
import isString from "lodash/isString";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import isArray from "lodash/isArray";
import isPlainObject from "lodash/isPlainObject";
import history from "utils/history";
import FeatureToggle from "components/FeatureToggle";
import PageHeader from "components/PageHeader";
import Stepper from "components/Stepper";
import Banner from "components/Banner";
import TimedMessageButton from "components/TimedMessageButton";
import {
  Box,
  Flex,
  Text,
  H1,
  H2,
  H3,
  H4,
  Button,
  Link,
  P,
  StyledLink,
  ImageFromBase64
} from "ui-components";
import PageNavigation from "components/PageNavigation";
import FAQ from "components/FAQ";
import PageFaqs from "components/PageFaqs";
import AddressLookup from "components/AddressLookup";
import AddOnSelection from "components/AddOnSelection";
import PayItemCard from "components/PayItemCard";
import PayMonthlyCard from "components/PayMonthlyCard";
import PayTodayCard from "components/PayTodayCard";
import OrderSummaryCard from "components/OrderSummaryCard";
import PlanDetailsCard from "components/PlanDetailsCard";
import OrderDetailsCard from "components/OrderDetailsCard";
import OrderStepsCard from "components/OrderStepsCard";
import OrderActionsCard from "components/OrderActionsCard";
import DeliveryDetailsCard from "components/DeliveryDetailsCard";
import NextStepsCard from "components/NextStepsCard";
import ESignCard from "components/ESignCard";
import PostOfficeCard from "components/PostOfficeCard";
import ProductItem from "components/ProductItem";
import PromoCodeBox from "components/PromoCodeBox";
import ToggleSwitch from "components/ToggleSwitch";
import NewNumberDisplay from "components/NewNumberDisplay";
import NumberSearch from "components/NumberSearch";
import NumberSelection from "components/NumberSelection";
import FormattedMessage from "components/FormattedMessage";
import DeliveryAddressForm1 from "components/DeliveryAddress/Form1";
import DeliveryAddressForm2 from "components/DeliveryAddress/Form2";
import DeliveryAddressForm3 from "components/DeliveryAddress/Form3";
import DeliveryAddressForm4 from "components/DeliveryAddress/Form4";
import DeliveryAddressForm5 from "components/DeliveryAddress/Form5";
import AcyenStorePicker from "components/DeliveryAddress/AcyenStorePicker";
import CheckboxField from "components/FormFields/CheckboxField";
import DropdownField from "components/FormFields/DropdownField";
import PortInNumberField from "components/FormFields/PortInNumberField";
import PortInTelcoAccountNumber from "components/FormFields/PortInTelcoAccountNumber";
import RadioGroup from "components/FormFields/RadioGroup";
import TextField from "components/FormFields/TextField";
import TextAreaField from "components/FormFields/TextAreaField";
import MultiTextField from "components/FormFields/MultiTextField";
import PhoneField from "components/FormFields/PhoneField";
import DateOfBirthField from "components/FormFields/DateOfBirthField";
import DeliveryMethodPicker from "components/DeliveryMethodPicker";
import PaymentMethodPicker from "components/PaymentMethodPicker";
import PostOfficePickUp from "components/PostOfficePickUp";
import LocationField from "components/FormFields/LocationField";
import DeliverySlotGroup from "components/FormFields/DeliverySlotGroup";
import RadioButtonGroup from "components/FormFields/RadioButtonGroup";
import DropIdentityField from "components/FormFields/DropIdentityField";
import Label from "components/FormFields/Label";
import PaymentBox from "components/PaymentBox";
import MockPaymentBox from "components/MockPaymentBox";
import PhoneList from "components/PhoneList";
import PhoneDetails from "components/PhoneDetails";
import StaticContentBox from "components/StaticContentBox";
import Spinner, { styles } from "components/Spinner";
import WirecardForm from "components/WirecardForm";
import WalletForm from "components/WalletForm";
import LegacyAdyenForm from "components/LegacyAdyenForm";
import AdyenDropin from "components/AdyenDropin";
import PayLaterForm from "components/PayLaterForm";
import StripeCheckoutForm from "components/StripeCheckout";
import StripePaymentForm from "components/StripePayment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { PlusCircleOutline } from "components/Icons";
import SocialMediaIcons from "components/SocialMediaIcons";
import SubmitButton from "components/SubmitButton";
import OTPBoxes from "components/OTPBoxes";
import NavigateLink from "components/NavigateLink";
import ESimCompatibleList from "containers/Plan/ConnectionDetails/ESimCompatibleList";
import payments from "./components/payments";
import SIMCountSelector from "components/SIMCountSelector";
import SpecialAddOnCard from "components/SpecialAddOnCard";
import Video from "components/Video";
import PopStationBox from "components/PopStationBox";
import PaymentUpdateCardAdyenDropIn from "./components/PaymentUpdateCardAdyenDropIn";
import PaymentUpfrontAdyenDropIn from "./components/PaymentUpfrontAdyenDropIn";
import PaymentUpfrontStripeCheckout from "./components/PaymentUpfrontStripeCheckout";
import PaymentUpfrontForm from "./components/PaymentUpfrontForm";
import PaymentUpdateForm from "./components/PaymentUpdateForm";
import OutstandingInvoiceCard from "components/OutstandingInvoiceCard";
import OutstandingPaymentCard from "components/OutstandingPaymentCard";
import MyInfoBox from "components/MyInfoBox";
import PaymentCardDetails from "./components/PaymentCardDetails";

import {
  COLORS,
  iconThemes,
  getButtonColorVariant,
  buttonThemes
} from "ui-components/theme";
import normalizers, { normalizerTypes } from "normalizers";
import Session from "session";
import {
  MANAGE_ORDER_URL,
  STANDALONE_WORKFLOW_PATHS,
  forms,
  paths,
  PHONE_ONLY_CHANNEL,
  PARTNERS_CHANNEL,
  DELIVERY_SLOT_TYPE_PHONE,
  DELIVERY_SLOT_TYPE_SIM,
  SELF_ACTIVATION_SIM,
  COMBO_CHANNEL,
  DELIVERY_SLOT_TYPE_SIM_AND_PHONE,
  STANDALONE_WORKFLOW_ROUTES,
  ORDER_CHANNEL_MAPPING,
  WEBSITE_V2,
  IS_PATHS_SECURED
} from "utils/constants";
import {
  setAddress,
  resetAddressFields,
  setPostOfficeAddressAsDeliveryAddress,
  constructOnChangeHandler,
  safeEval,
  gotoUrl,
  urlParam,
  evalProp,
  isMobile,
  mapAddressComponentOption,
  getChannelFromUrl,
  getValueOrLabel,
  isWorkflowChannel,
  formatCurrency,
  getGopayActionUrls,
  getOnSubmitActionHandler,
  isTabletOrDeskTop,
  getURLParams,
  parseConditionVariables,
  handleMaintenanceBanner
} from "utils/helpers";
import {
  makeSelectWorkflow,
  makeSelectAppSettings,
  makeSelectCurrencyFormat,
  makeSelectPlanName,
  makeSelectPlanTextName,
  makeSelectPayTodayItems,
  makeSelectPayMonthlyItems,
  makeSelectPhoneVariant,
  makeSelectPhonePaymentOption,
  makeSelectUserDetails,
  makeSelectIsFetchingAnyData,
  makeSelectThemeColors,
  makeSelectChannelPhonePaymentOptions,
  makeSelectEnableSimCountNextButton
} from "ducks/selectors";
import {
  isWebview,
  isNative,
  getLocaleOrDefault,
  setLandingPage,
  resetLandingPage,
  getLandingPage,
  setLandingPageVisited,
  getLandingPageVisited,
  setItem,
  setSessionToken
} from "utils/localStorage";
import PayDeviceCard from "components/PayDeviceCard";
import { Field } from "redux-form";
import SimDetailsCard from "components/SimDetailsCard";
import CriticalInfoSummary from "components/CriticalInfoSummary";
import DetailBox from "components/DetailBox";
import ESignField from "components/ESignField";
import AmazonWalletWidget from "./components/amazomPay/amazanWalletWidget";
import Accordion from "components/Accordion";
import DateSlotSelection from "components/DateSlotSelection";
import OrderAuthorizationCard from "components/OrderAuthorizationCard";
import PaymentUpdateCardStripeCheckout from "./components/PaymentUpdateCardStripeCheckout";
// v3 of the stripe update card
import StripeUpdateCard from "./components/updateCard/stripeUpdateCard";
import OTPEmail from "components/OTPEmail";
import EmailOTPBoxes from "components/EmailOTPBoxes";
import orderBy from "lodash/orderBy";
import NotEligible from "components/NotEligible";
import ExtendedPlanSelection from "./components/ExtendedPlanSelection";
import SectionListModal from "components/SectionListModal";
import SmartComponents from "./SmartComponents";
import BarcodeScanner from "components/BarcodeScanner";
import ErrorModal from "components/ErrorModal/index";
import { REPLIT_REDIRECT_URL } from "../../utils/constants";
import AddSims from "components/EnterpriseAutomated/AddSim/index";
import ThingsToKnow from "components/EnterpriseAutomated/ThingsToKnow/index";
import EntFAQ from "components/EnterpriseAutomated/PageFaqs/index";
import EntSingpass from "components/EnterpriseAutomated/MyInfoBox/index";
import EkycVerification from "components/EnterpriseAutomated/EkycVerifiaction/index";
import AcraUpload from "components/EnterpriseAutomated/AcraUpload/index";
import CompanyDetailsDeclaration from "components/EnterpriseAutomated/CompanyDetailsDeclaration/index";
import AccountHolderDetails from "components/EnterpriseAutomated/AccountHolderDetails/index";
import SecondaryContact from "components/EnterpriseAutomated/SecondayContact/index";
import BillingDetails from "components/EnterpriseAutomated/BillingDetails/index";
import EntToggleSwitch from "components/EnterpriseAutomated/ToggleSwitch/index";
import AutomatedPageNavigation from "components/EnterpriseAutomated/PageNavigation/index";
import AddSimSummary from "components/EnterpriseAutomated/AddSimSummary/index";
import CompanyDetailsSummary from "components/EnterpriseAutomated/CompanyDetailsSummary/index";
import AccountHolderSummary from "components/EnterpriseAutomated/AccountHolderSummary/index";
import MonthlyPlanCard from "components/EnterpriseAutomated/MonthlyPlanCard/index";
import PaymentDetails from "components/EnterpriseAutomated/PaymentDetails/index";
import EntPromoCodeBox from "components/EnterpriseAutomated/PromoCodeBox/index";
import EntErrorModal from "components/EnterpriseAutomated/ErrorModal/index";
import EntAddOnSelection from "components/EnterpriseAutomated/AddOnSelection/index";


const featureMapping = {
  ...SmartComponents,
  DEAL_SELECTION: props => {
    const deals = props.generic?.deals;
    if (isEmpty(props.generic?.deals)) return null;

    const { loading, value } = props?.referralCode || {};
    const planName = props.planDetails?.name;
    const deviceSku = props.selectedPhone
      ? props.selectedPhone?.deviceSku
      : null;
    const orderRef = props.orderDetails?.order?.order_ref;
    return (
      <ToggleSwitch
        {...props}
        value={value}
        valueAttribute={"promocode"}
        onClick={item => {
          if (!loading) {
            props.clearSelectAddon();
            props.resetReferralCode();
            const dealPlanName = item.plan || "CirclesOne";
            console.log("Selecting Deal Plan - ", dealPlanName);
            if (dealPlanName !== planName) {
              const dealPlan = find(props.eligiblePlans, [
                "name",
                dealPlanName
              ]);
              if (dealPlan) {
                console.log("Selected Deal Plan - ", dealPlanName, dealPlan);
                gotoUrl(
                  window.location.pathname,
                  true,
                  {
                    reset: true,
                    plan_name: dealPlanName,
                    code: item.promocode
                  },
                  true
                );
              }
            } else {
              props.validateReferralCode(
                item.promocode,
                planName,
                deviceSku,
                orderRef
              );
            }
          }
        }}
        loading={loading}
        items={deals}
        data={props.data}
        regularScreenItemsPerRow={props.data?.regularScreenItemsPerRow || 2}
        mobileScreenItemsPerRow={props.data?.mobileScreenItemsPerRow || 1}
        {...deals}
      />
    );
  },
  SECTION_LIST_MODAL: props => {
    const {
      data,
      showSectionListModal,
      setSectionListModal,
      changeField,
      payMonthlyItems,
      countries
    } = props;
    const planCountries = get(payMonthlyItems, "planCountries", []);

    const defaultOverlayStyle = {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.70)",
      zIndex: 2000
    };
    const defaultContentStyle = {
      position: "absolute",
      border: "1px solid #ccc",
      background: "rgba(247, 246, 246, 100)",
      overflow: "scroll",
      borderRadius: "12px",
      outline: "none",
      padding: "0px",
      maxWidth: "570px",
      maxHeight: "570px",
      margin: "auto",
      inset: "1rem"
    };

    const modalStyle = {
      overlay: { ...defaultOverlayStyle },
      content: { ...defaultContentStyle }
    };

    let mapData = [
      // sample
      // {
      //   rows: [{
      //     country_code: "AU",
      //     item_caption: "Australia",
      //     item_descriptions: ['Optus', 'Telstra', 'Vodafone AU']
      //   }],
      //   section: "A"
      // }
    ];
    for (let key in countries) {
      let countryCode = countries[key]?.iso2_code || "";
      let countryName = countries[key]?.name || "";
      if (planCountries.includes(countryCode.toLowerCase())) {
        const found = mapData.filter(obj => obj.section === countryName[0]);
        const row = {
          country_code: countryCode,
          item_caption: countries[key].name,
          item_descriptions: countries[key].roaming_partners
        };

        // if section exist
        if (!isEmpty(found)) {
          found[0].rows.push(row);
        } else {
          // if the section is new
          mapData.push({
            rows: [row],
            section: countryName[0].toUpperCase()
          });
        }
      }
    }

    return (
      <SectionListModal
        modalStyle={modalStyle}
        mapData={mapData || []}
        data={{ ...data, planCountries }}
        setModal={setSectionListModal}
        changeField={changeField}
        isOpen={showSectionListModal}
      />
    );
  },
  HTML_LINK: ({ label, textColor, onsubmit, underLine, ...props }) => {
    const underLineLink = underLine ? { textDecoration: "underline" } : null;
    const color = textColor ? { color: "#000000" } : null;
    return (
      <Box mt={[24, 36]} sx={{ textAlign: "center" }} onClick={props[onsubmit]}>
        <StyledLink sx={underLineLink} style={color}>
          <FormattedMessage id={label} />
        </StyledLink>
      </Box>
    );
  },
  DETAIL_BOX: ({ data = {}, generic, ...props }) => {
    return <DetailBox {...props} {...data} generic={generic} />;
  },
  STATIC_CONTENT_BOX: ({ data, messageData, themeColors, ...props }) => (
    <StaticContentBox
      {...props}
      {...data}
      messageData={messageData}
      themeColors={themeColors}
    />
  ),
  HR: ({ data = {} }) => <hr style={{ padding: "1rem", ...data.style }} />,
  IMAGE: ({ data = {}, ...props }) => {
    const { alt, style, boxVariant, boxPadding, boxMarginBottom } = data;
    const locale = getLocaleOrDefault();
    const device = isMobile() ? "mobile" : "desktop";
    const src = get(data, ["src", locale, device], data.src);
    const dynamicSrc = safeEval(
      get,
      props.formValues,
      get(data, "dynamic_src"),
      null,
      props,
      ""
    );
    const imageSrc = dynamicSrc || src;
    return isEmpty(imageSrc) ? null : (
      <Box
        variant={boxVariant || "transparent"}
        padding={boxPadding || "0"}
        mb={boxMarginBottom || "0"}
      >
        <img
          alt={alt}
          src={imageSrc}
          style={style}
          width="100%"
          height="auto"
        />
      </Box>
    );
  },
  IMAGE_WITH_BASE64: props => <ImageFromBase64 {...props} />,
  TEXT_FIELD: ({ data, ...props }) => {
    const { disabled, formValues } = props;

    const isDisabled = safeEval(get, formValues, disabled, false, props);

    return (
      <TextField
        {...props}
        {...data}
        onChange={constructOnChangeHandler(props)}
        disabled={isDisabled}
      />
    );
  },
  MULTI_TEXT_FIELD: ({ data, ...props }) => {
    return (
      <MultiTextField
        {...props}
        {...data}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  CHECKBOX_FIELD: ({ data, ...props }) => {
    const defaultChecked = safeEval(
      get,
      props.formValues,
      get(props, "defaultChecked"),
      false,
      props
    );
    return (
      <CheckboxField
        {...props}
        {...data}
        defaultChecked={defaultChecked}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  HTML_MESSAGE: ({ data, messageData, styles }) => (
    <Box mb={get(data, "marginBottom", 8)} sx={styles}>
      <FormattedMessage html id={data.message} values={messageData} />
    </Box>
  ),
  DROPDOWN_FIELD: ({ options, data, ...props }) => {
    return (
      <DropdownField
        {...props}
        {...data}
        options={evalProp(props, options, [])}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  STEPPER: ({ data, themeColors, standalone }) => (
    <Stepper {...data} themeColors={themeColors} standalone={standalone} />
  ),
  PAGE_HEADER: ({ data, messageData, themeColors }) => (
    <PageHeader {...data} {...messageData} themeColors={themeColors} />
  ),
  NOT_ELIGIBLE: ({ data, messageData, themeColors }) => (
    <NotEligible {...data} themeColors={themeColors} />
  ),
  PROMO_CODE_BOX: props => {
    const {
      defaultPromoCodeOffers,
      resetReferralCode,
      validateReferralCode,
      referralCode,
      locale,
      data = {},
      themeColors,
      planName,
      selectedPhone,
      orderDetails,
      appSettings
    } = props;
    const orderRef = get(orderDetails, "order.order_ref");
    const { loading, valid, reason, value, title, benefits } =
      referralCode || {};
    const deviceSku = selectedPhone ? selectedPhone.deviceSku : null;
    return (
      <Box mb={8}>
        <PromoCodeBox
          loading={loading}
          valid={valid}
          reason={reason}
          defaultValue={value}
          defaultPromoCodeOffers={defaultPromoCodeOffers}
          onChange={resetReferralCode}
          title={title}
          benefits={benefits}
          locale={locale}
          onSubmit={code =>
            validateReferralCode(code, planName, deviceSku, orderRef)
          }
          label={get(data, "title")}
          readonly={get(data, "readonly")}
          hideBenefits={get(data, "hideBenefits")}
          themeColors={themeColors}
          appSettings={appSettings}
          orderDetails={orderDetails}
          showOnlyBenefits={get(data, "showOnlyBenefits")}
        />
      </Box>
    );
  },
  BARCODE_SCANNER: props => <BarcodeScanner {...props} />,
  PAY_MONTHLY_CARD: ({ payMonthlyItems, data: { append = [], ...rest } }) => {
    let items = [...payMonthlyItems.items, ...append];

    return (
      <Box mb={6}>
        <PayItemCard
          {...payMonthlyItems}
          items={items}
          title={"pay_monthly"}
          {...rest}
        />
      </Box>
    );
  },
  PAY_TODAY_CARD: ({ payTodayItems, data: { append = [], ...rest } }) => {
    let items = [...payTodayItems.items, ...append];

    return (
      <Box mb={6}>
        <PayItemCard
          {...payTodayItems}
          items={items}
          title={"pay_today"}
          {...rest}
        />
      </Box>
    );
  },
  PLAN_SELECTION: props => {
    const {
      currencyFormat,
      eligiblePlans,
      planDetails,
      selectPlan,
      iccIdDetails,
      tabType,
      data,
      themeColors,
      resetReferralCode,
      validateReferralCode,
      referralCode
    } = props;
    const [allowedPlans, setAllowedPlans] = useState(eligiblePlans);
    const { badges, icons } = data;
    const allowedEligiblePlans = get(data, "allowedPlans");
    const features = get(data, "features", []);
    const urlPlanName = urlParam("plan_name");

    useEffect(
      () => {
        if (!isEmpty(eligiblePlans && !get(iccIdDetails, COMBO_CHANNEL))) {
          // eligiblePlans will contain only the sim plan if it is valid.
          // otherwise all eligible plans for channel will be present
          let allowedPlans = eligiblePlans;
          if (!isEmpty(allowedEligiblePlans)) {
            // GROW-1312: filter eligiblePlans to control plans available for customer selection
            allowedPlans = filter(eligiblePlans, ({ name }) =>
              includes(allowedEligiblePlans, name)
            );
          }
          let plan = head(allowedPlans);
          if (urlPlanName) {
            const urlPlan = find(eligiblePlans, { name: urlPlanName });
            if (!isEmpty(urlPlan)) {
              // show only urlPlan if it is eligible
              plan = urlPlan;
              allowedPlans = [urlPlan];
            }
          }
          if (!isEmpty(planDetails)) {
            const selectedPlan = find(eligiblePlans, {
              name: planDetails.name
            });
            if (!isEmpty(selectedPlan)) {
              // clear plan to avoid plan selection
              // if an allowed plan is already selected
              plan = undefined;
              // show only selectedPlan if it is eligible but allowedPlans is empty
              if (isEmpty(allowedPlans)) {
                allowedPlans = [selectedPlan];
              }
            }
          }
          !isEmpty(plan) && selectPlan(plan);
          // set allowedPlans to control the options shown for user selection
          setAllowedPlans(allowedPlans);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        planDetails,
        eligiblePlans,
        allowedEligiblePlans,
        urlPlanName,
        setAllowedPlans
      ]
    );

    const label = get(data, "toggle_label", "data_gb");
    let items = map(allowedPlans, ({ name, data, basicPrice }) => ({
      name,
      label,
      value: name,
      data,
      basicPrice,
      totalData: data,
      totalAmount: basicPrice,
      totalPrice: formatCurrency(basicPrice, currencyFormat),
      totalFixedPrice: formatCurrency(basicPrice, currencyFormat, false, 0)
    }));
    const order = get(data, "order", {});
    if (!isEmpty(order)) {
      const order_key = get(data, "order.key", ["data"]);
      const order_by = get(data, "order.by", ["asc"]);
      items = orderBy(items, order_key, order_by);
    }
    const valueAttribute = "name";
    const onClick = plan => {
      if (!isEmpty(referralCode) && referralCode.value) {
        resetReferralCode();
        validateReferralCode(referralCode.value, plan.name, null);
      }
      selectPlan(
        find(allowedPlans, { [valueAttribute]: plan[valueAttribute] })
      );
    };

    const showSummary =
      get(data, "showSummary") || get(data, "cardType") === "payMonthlyDetails";

    return (
      <>
        {items.length > 1 && (
          <ToggleSwitch
            items={items}
            value={get(planDetails, valueAttribute)}
            valueAttribute={valueAttribute}
            onClick={onClick}
            type={tabType}
            features={features}
            badges={badges}
            icons={icons}
            themeColors={themeColors}
            data={data}
          />
        )}
        <PlanDetailsCard {...props} data={{ ...data, showSummary }} />
      </>
    );
  },
  EXTENDED_PLAN_SELECTION: props => <ExtendedPlanSelection {...props} />,
  PAY_DEVICE_CARD: props => <PayDeviceCard {...props} />,
  PAY_MONTHLY_DETAILS_CARD: ({ data, ...props }) => (
    <PlanDetailsCard
      {...props}
      data={{ ...data, showSummary: true }}
      data-testid="pay-monthly-details-card"
    />
  ),
  PAY_MONTHLY_SUMMARY_CARD: props => (
    <PayMonthlyCard {...props} data-testid="pay-monthly-summary-card" />
  ),
  PAY_TODAY_SUMMARY_CARD: props => (
    <PayTodayCard {...props} data-testid="pay-today-summary-card" />
  ),
  ORDER_SUMMARY_CARD: props => (
    <OrderSummaryCard {...props} data-testid="order-summary-card" />
  ),
  PLAN_DETAILS_CARD: props => (
    <PlanDetailsCard {...props} data-testid="plan-details-card" />
  ),
  ORDER_DETAILS_CARD: props => (
    <OrderDetailsCard {...props} data-testid="order-details-card" />
  ),
  ORDER_STEPS_CARD: props => (
    <OrderStepsCard {...props} data-testid="order-steps-card" />
  ),
  ORDER_ACTIONS_CARD: props => (
    <OrderActionsCard {...props} data-testid="order-actions-card" />
  ),
  DELIVERY_DETAILS_CARD: ({
    deliveryDetailsItems,
    order,
    orderParams,
    orderSummary,
    orderDetails,
    selectedNumber,
    data,
    themeColors,
    personalDetailFormsValues
  }) => {
    const details = isEmpty(orderDetails) ? deliveryDetailsItems : orderDetails;
    return (
      <Box mb={6}>
        <DeliveryDetailsCard
          details={details}
          order={order}
          orderParams={orderParams}
          orderSummary={orderSummary}
          selectedNumber={selectedNumber}
          themeColors={themeColors}
          personalDetailFormsValues={personalDetailFormsValues}
          {...data}
        />
      </Box>
    );
  },
  BILLING_DETAILS_CARD: ({
    deliveryDetailsItems,
    order,
    orderSummary,
    orderDetails,
    selectedNumber,
    data,
    themeColors
  }) => {
    const details = isEmpty(orderDetails) ? deliveryDetailsItems : orderDetails;
    return (
      <Box mb={6}>
        <DeliveryDetailsCard
          details={details}
          order={order}
          orderSummary={orderSummary}
          selectedNumber={selectedNumber}
          themeColors={themeColors}
          showPersonalDetails={false}
          showDeliveryDetails={false}
          showDeliveryTime={false}
          showBillingDetails={true}
          {...data}
        />
      </Box>
    );
  },
  NEXT_STEPS_CARD: props => {
    const { data, themeColors } = props;
    return (
      <Box mb={6}>
        <NextStepsCard {...data} themeColors={themeColors} />
      </Box>
    );
  },
  ESIGN_CARD: ({ uploadSignature, data }) => {
    return (
      <Box mb={6}>
        <ESignCard onUpload={uploadSignature} {...data} />
      </Box>
    );
  },
  SPECIAL_ADDON: ({
    data,
    changeField,
    formValues,
    isMultiSimOrder,
    themeColors,
    hideAddon,
    currencyFormat,
    appSettings
  }) => {
    const { ms } = getURLParams();
    const addonType = get(data, "type");
    const addonPrice = get(appSettings, `generic.${addonType}.price`);
    const price = addonPrice
      ? formatCurrency(addonPrice, currencyFormat, true)
      : get(data, "price");
    useEffect(() => {
      changeField(addonType, !!ms || isMultiSimOrder);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMultiSimOrder]);
    return (
      <SpecialAddOnCard
        hideAddon={hideAddon}
        themeColors={themeColors}
        selected={get(formValues, addonType, false)}
        {...data}
        price={price}
        onSelect={() => changeField(addonType, !get(formValues, addonType))}
      />
    );
  },
  ADDONS_CHECKBOX: ({
    addOns,
    defaultAddons,
    handleSelectAddon,
    data,
    themeColors,
    hideAddon,
    is5GCompatible
  }) => (
    <AddOnSelection
      hideAddon={hideAddon}
      items={addOns}
      defaultAddons={defaultAddons}
      onSelect={handleSelectAddon}
      {...data}
      themeColors={themeColors}
      is5GCompatible={is5GCompatible}
    />
  ),
  PORT_IN_AGREE_TO_TNC_CHECKBOX: props => <CheckboxField {...props} />,
  ADDONS_DROPDOWN: ({ addOns, defaultAddons, ...props }) => (
    <DropdownField
      options={addOns}
      defaultAddons={defaultAddons}
      {...props}
      onChange={constructOnChangeHandler(props)}
    />
  ),
  STATE_OF_ISSUE: ({ issuingStates, ...props }) => (
    <DropdownField
      options={issuingStates}
      {...props}
      onChange={constructOnChangeHandler(props)}
    />
  ),
  COUNTRY_OF_ISSUE: ({ issuingCountries, ...props }) => (
    <DropdownField
      options={issuingCountries}
      {...props}
      onChange={constructOnChangeHandler(props)}
    />
  ),
  PAGE_NAVIGATION: props => {
    const {
      onSubmit = navigate => navigate(),
      handleSubmit,
      nextPage,
      data,
      payload = {},
      uploadScreenshot,
      form,
      screenshotEnabled,
      planTextName,
      payTodayItems,
      payMonthlyItems,
      transactionAmount,
      formValues,
      themeColors,
      pristine,
      invalid,
      fallbackUrl,
      phoneVariant,
      phonePaymentOption,
      loading = false,
      sim_count,
      screenshot,
      clearScreenshot,
      isFetchingAnyData,
      outstandingBillAmount,
      appSettings,
      currencyFormat
    } = props;

    const ignoreLoader = get(data, "next.ignoreLoader", false);
    const isLoading = !ignoreLoader && (loading || isFetchingAnyData);
    const disableNext =
      isLoading ||
      safeEval(get, formValues, get(data, "next.disabled"), false, props);
    let nextPath = get(data, "next.path", "") || nextPage;
    const reload = get(data, "next.reload", false);
    const preserveQuery = get(data, "next.preserve", true);
    const queryOverride = get(data, "next.override", {
      reset: undefined,
      locale: undefined
    });
      // This is enterpice liveness check POC 
    const enterpiseLivenessCheckEnable  = get(appSettings, "enable_enterprise_liveness_check") || false
    const channel = getChannelFromUrl();
    if(channel === "enterprise" && window.location.pathname === "/enterprise/new-number" && enterpiseLivenessCheckEnable){
      nextPath = REPLIT_REDIRECT_URL
    }
    const navigate = () =>
      nextPath && gotoUrl(nextPath, preserveQuery, queryOverride, reload);
    const onSubmitOverride =
      get(data, "next.onsubmit") || get(data, "next.onSubmit");
    const submit = values =>
      onSubmit(
        navigate,
        isEmpty(payload) ? values : payload,
        onSubmitOverride,
        data
      );

    const payNowPrice = get(payTodayItems, "totalPrice");
    const numberItem = find(payTodayItems?.items, { type: "number" });
    const numberItemPrice = numberItem?.value || 0;
    const numberPrice = formatCurrency(numberItemPrice, currencyFormat);
    const ignoreForm = get(data, "next.ignoreForm", false);
    const hidePrevIcon =
      get(appSettings, "ui.hide_prev_icon") && !get(data, "prev.showIcon");
    return (
      <PageNavigation
        onNextClick={
          handleSubmit && !ignoreForm ? handleSubmit(submit) : submit
        }
        uploadScreenshot={uploadScreenshot}
        form={form}
        sim_count={sim_count}
        screenshotEnabled={screenshotEnabled}
        planName={planTextName}
        payNowPrice={payNowPrice}
        numberPrice={numberPrice}
        {...payMonthlyItems}
        transactionAmount={transactionAmount}
        disableNext={disableNext}
        themeColors={themeColors}
        fallbackUrl={fallbackUrl}
        phoneVariant={phoneVariant}
        phonePaymentOption={phonePaymentOption}
        loading={isLoading}
        {...data}
        invalid={invalid}
        pristine={pristine}
        screenshot={screenshot}
        clearScreenshot={clearScreenshot}
        outstandingBillAmount={outstandingBillAmount}
        hidePrevIcon={hidePrevIcon}
        appSettings={appSettings}
      />
    );
  },
  QUICK_ORDER_VIEW: ({ messageData, ...props }) => {
    const { title, subtitle, details, onclick } = get(
      props,
      "component.data",
      {}
    );
    const detailsList = details && get(props, details, []);
    return (
      <>
        {title && (
          <H4
            pt={3}
            style={{ fontFamily: "Roboto", fontWeight: 700 }}
            onClick={props[onclick]}
          >
            <FormattedMessage style={{ color: "blue" }} html id={title} />
          </H4>
        )}
        {subtitle && (
          <H4 pt={2} pb={2} style={{ fontFamily: "Roboto", fontWeight: 500 }}>
            {" "}
            <FormattedMessage html id={subtitle} values={messageData} />
          </H4>
        )}
        {detailsList?.length && (
          <H4 pt={2} pb={2} style={{ fontFamily: "Roboto", fontWeight: 400 }}>
            {detailsList.map(detail => (
              <Text>{detail?.label}</Text>
            ))}
          </H4>
        )}
      </>
    );
  },
  VIDEO_PLAYER: ({ data, ...props }) => {
    const [showVideo, setShowVideo] = useState(false);

    const {
      video_src,
      close_icon,
      styles,
      title,
      src,
      subtitle,
      componentStyles
    } = data;

    const videoHandler = useCallback(
      event => {
        if (event.target.className === "video_container") return;
        if (showVideo) {
          setShowVideo(false);
        }
      },
      [showVideo]
    );

    useEffect(
      () => {
        window.addEventListener("click", videoHandler);
        return () => {
          window.removeEventListener("click", videoHandler);
        };
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [showVideo, videoHandler]
    );
    return (
      <>
        {title && (
          <div style={{ display: "flex", marginTop: 30, ...componentStyles }}>
            <img src={src} alt="success" style={{ height: 50, width: 60 }} />
            <div>
              <FormattedMessage html id={title} />
              <div class="video_container" onClick={() => setShowVideo(true)}>
                <FormattedMessage html id={subtitle} />
              </div>
            </div>
          </div>
        )}
        {showVideo && (
          <Video
            closeIcon={close_icon}
            videoUrl={video_src}
            styles={styles}
            hidePlayer={() => setShowVideo(false)}
          />
        )}
      </>
    );
  },
  MODAL_BUTTONS: props => {
    const {
      component: { items },
      isOrderCreating,
      themeColors
    } = props;
    const flexDirection = !isTabletOrDeskTop() ? "column-reverse" : "row";
    const buttonTheme = get(themeColors, "button") || buttonThemes.blue;

    return (
      <Flex
        mt={3}
        justifyContent="center"
        alignItems="center"
        flexDirection={flexDirection}
      >
        {map(items, (element, index) => (
          <FormattedMessage id={element.text}>
            {msg =>
              element.type === "link" ? (
                <a
                  style={element.styles}
                  href={element.href}
                  onClick={() =>
                    safeEval(get, props.formValues, element.onClick, "", props)
                  }
                >
                  {msg}
                </a>
              ) : (
                <Button
                  disabled={isOrderCreating}
                  sx={getButtonColorVariant(buttonTheme, element.variant)}
                  style={element.styles}
                  mx={1}
                  variant={element.variant}
                  onClick={() =>
                    safeEval(get, props.formValues, element.onClick, "", props)
                  }
                >
                  {isOrderCreating && element.showLoader ? (
                    <Spinner size={19} sx={styles.button} />
                  ) : (
                    msg
                  )}
                </Button>
              )
            }
          </FormattedMessage>
        ))}
      </Flex>
    );
  },
  PLAN_BANNER: ({ planName, data, appSettings }) => (
    <Banner
      type={"planBanners"}
      value={planName}
      data={data}
      appSettings={appSettings}
    />
  ),
  PLAN_FAQ: props => {
    return (
      <Box mt={8}>
        <FAQ items={[{ title: "", description: props.planFAQ }]} />
      </Box>
    );
  },
  FAQ_LIST: ({ data }) => (
    <Box mt={8}>
      <FAQ {...data} />
    </Box>
  ),
  SWITCH_TOGGLE: props => {
    const {
      data,
      value = window.location.pathname,
      valueAttribute = "href",
      onClick = item => gotoUrl(item.href, true),
      ...rest
    } = props;
    return (
      <ToggleSwitch
        value={value}
        valueAttribute={valueAttribute}
        onClick={onClick}
        data={data}
        {...data}
        {...rest}
      />
    );
  },
  FIELD_TOGGLE: props => {
    const { data, valueAttribute = "value", formValues, change } = props;
    const field = get(data, "field");
    const value = get(formValues, field);
    console.log("SIM TYPE PROPS", props)
    return (
      <ToggleSwitch
        {...props}
        value={value}
        valueAttribute={valueAttribute}
        onClick={item => {
          change && change(field, get(item, [valueAttribute]));
        }}
        data={data}
        {...data}
      />
    );
  },
  AUTOMATED_PAGE_NAVIGATION: props => {
    const {
      onSubmit = navigate => navigate(),
      handleSubmit,
      nextPage,
      data,
      payload = {},
      uploadScreenshot,
      form,
      screenshotEnabled,
      planTextName,
      payTodayItems,
      payMonthlyItems,
      transactionAmount,
      formValues,
      themeColors,
      pristine,
      invalid,
      fallbackUrl,
      phoneVariant,
      phonePaymentOption,
      loading = false,
      sim_count,
      screenshot,
      clearScreenshot,
      isFetchingAnyData,
      outstandingBillAmount,
      appSettings,
      currencyFormat,
      simCounts,
      auditLogData
    } = props;
    const { workflow } = auditLogData || {}
    const ignoreLoader = get(data, "next.ignoreLoader", false);
    const isLoading = !ignoreLoader && (loading || isFetchingAnyData);
    const disableNext =
      isLoading ||
      safeEval(get, formValues, get(data, "next.disabled"), false, props);
    let nextPath = get(data, "next.path", "") || nextPage;
    const reload = get(data, "next.reload", false);
    const preserveQuery = get(data, "next.preserve", true);
    const queryOverride = get(data, "next.override", {
      reset: undefined,
      locale: undefined
    });
      // This is enterpice liveness check POC 
    // const enterpiseLivenessCheckEnable  = get(appSettings, "enable_enterprise_liveness_check") || false
    // const channel = getChannelFromUrl();

    if(urlParam('edit') && workflow === 'review_order'){
      nextPath = '/enterprise/automated-review-order'
    }
    const navigate = () =>
      nextPath && gotoUrl(nextPath, preserveQuery, queryOverride, reload);
    const onSubmitOverride =
      get(data, "next.onsubmit") || get(data, "next.onSubmit");
    const submit = values =>
      onSubmit(
        navigate,
        isEmpty(payload) ? values : payload,
        onSubmitOverride,
        data
      );

    const payNowPrice = get(payTodayItems, "totalPrice");
    const numberItem = find(payTodayItems?.items, { type: "number" });
    const numberItemPrice = numberItem?.value || 0;
    const numberPrice = formatCurrency(numberItemPrice, currencyFormat);
    const ignoreForm = get(data, "next.ignoreForm", false);
    const hidePrevIcon =
    get(appSettings, "ui.hide_prev_icon") && !get(data, "prev.showIcon");
    return (
      <AutomatedPageNavigation
        onNextClick={
          handleSubmit && !ignoreForm ? handleSubmit(submit) : submit
        }
        uploadScreenshot={uploadScreenshot}
        form={form}
        sim_count={sim_count}
        screenshotEnabled={screenshotEnabled}
        planName={planTextName}
        payNowPrice={payNowPrice}
        numberPrice={numberPrice}
        {...payMonthlyItems}
        transactionAmount={transactionAmount}
        disableNext={disableNext}
        themeColors={themeColors}
        fallbackUrl={fallbackUrl}
        phoneVariant={phoneVariant}
        phonePaymentOption={phonePaymentOption}
        loading={isLoading}
        {...data}
        invalid={invalid}
        pristine={pristine}
        screenshot={screenshot}
        clearScreenshot={clearScreenshot}
        outstandingBillAmount={outstandingBillAmount}
        hidePrevIcon={hidePrevIcon}
        appSettings={appSettings}
        simCounts={simCounts}
      />
    );
  },
  ENT_FIELD_TOGGLE: props => {
    const { data, valueAttribute = "value", formValues, change } = props;
    const field = get(data, "field");
    const value = get(formValues, field);
    return (
      <EntToggleSwitch
        {...props}
        value={value}
        valueAttribute={valueAttribute}
        onClick={item => {
          change && change(field, get(item, [valueAttribute]));
        }}
        data={data}
        {...data}
      />
    );
  },
  ENT_PROMO_CODE_BOX: props => {
    const {
      defaultPromoCodeOffers,
      resetReferralCode,
      validateReferralCode,
      referralCode,
      locale,
      data = {},
      themeColors,
      planName,
      selectedPhone,
      orderDetails,
      appSettings,
      planDetails
    } = props;
    const orderRef = get(orderDetails, "order.order_ref");
    const { loading, valid, reason, value, title, benefits } =
      referralCode || {};
    const deviceSku = selectedPhone ? selectedPhone.deviceSku : null;
    return (
      <>
        {loading ? (
          <Box
            width="100%"
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Spinner size={60} />
          </Box>
        ) : (
          <Box mb={3}>
            <EntPromoCodeBox
              loading={loading}
              valid={valid}
              reason={reason}
              defaultValue={value}
              defaultPromoCodeOffers={defaultPromoCodeOffers}
              onChange={resetReferralCode}
              title={title}
              benefits={benefits}
              locale={locale}
              onSubmit={code =>
                validateReferralCode(code, planName, deviceSku, orderRef)
              }
              label={get(data, "title")}
              readonly={get(data, "readonly")}
              hideBenefits={get(data, "hideBenefits")}
              themeColors={themeColors}
              appSettings={appSettings}
              orderDetails={orderDetails}
              showOnlyBenefits={get(data, "showOnlyBenefits")}
              planDetails={planDetails}
            />
          </Box>
        )}
      </>
    );
  },
  ADD_SIMS: props => {
    return (
      <AddSims {...props} />
    );
  },
  THINGS_TO_KNOW: props => {
    return (
     <ThingsToKnow {...props} />
    );
  },
  ENT_ADDONS_CHECKBOX: ({
    addOns,
    defaultAddons,
    handleSelectAddon,
    data,
    themeColors,
    hideAddon,
    is5GCompatible
  }) => (
    <EntAddOnSelection
      hideAddon={hideAddon}
      items={addOns}
      defaultAddons={defaultAddons}
      onSelect={handleSelectAddon}
      {...data}
      themeColors={themeColors}
      is5GCompatible={is5GCompatible}
    />
  ),
  ENT_SINGPASS: ({ data, ...props }) => {
    return (
      <EntSingpass  {...props} {...data}/>
    )
  },
  ENT_SINGPASS_VERIFICATION: ({ data, ...props }) => {
    return (
      <EkycVerification {...props} {...data} />
    )
  },
  ENT_ERROR_MODAL: (props) => {
    return (
      <EntErrorModal {...props} />
    )
  },
  ACRA_UPLOADER: ({
    imageUploading,
    imageUploaded,
    uploadImage,
    appSettings,
    data,
    themeColors,
    ...props
  }) => {

    const type = get(data, "type") || "primary";

    return (
      <AcraUpload
        label={'Acra Upload File'}
        type={type}
        frontOrBack=""
        loading={get(imageUploading, ".oa")}
        onDrop={uploadImage}
        completed={get(imageUploaded, ".oa")}
        testid={`${type}_image_uploader`}
        accept=".oa"
        maxSize={8 * 1024 * 1024}
        themeColors={themeColors}
      />
    );
  },
  COMPANY_DETAILS_DECLARATION_FORM: (props) => {
    return (
      <CompanyDetailsDeclaration {...props} />
    )
  },
  ACCOUNT_DETAILS_FORM: (props) =>{
    return (
      <AccountHolderDetails {...props} />
    )
  },
  SECONDARY_CONTACT_DETAILS_FORM: (props) => {
    return (
      <SecondaryContact {...props}/>
    )
  },
  BILLING_DETAILS_FORM: (props) => {
    return (
      <BillingDetails {...props} />
    )
  },
  SIM_SUMMARY: (props) => {
    return (
      <AddSimSummary {...props}/>
    )
  },
  COMPANY_DETAILS_SUMMARY: (props) => {
    return (
      <CompanyDetailsSummary {...props}/>
    )
  },
  ACCOUNT_HOLDER_SUMMARY: (props) => {
    return (
      <AccountHolderSummary {...props} />
    )
  },
  MONTHLY_PAY_CARD: (props) => {
    return (
      <MonthlyPlanCard {...props} />
    )
  },
  ENT_PAYMENT_DETAILS: (props) => {
    return (
      <PaymentDetails {...props} />
    )
  },
  ENT_PAYMENT_FORM: ({
    isCreatingOrder,
    isFetchingPaymentRequest,
    order,
    paymentRequest,
    fetchPaymentRequest,
    clearPaymentRequest,
    token,
    appSettings,
    locale,
    formValues,
    canRequestPayment = true
  }) => {
    const loading =
      isEmpty(order) ||
      isEmpty(paymentRequest) ||
      isCreatingOrder ||
      isFetchingPaymentRequest;
    const order_ref = get(order, "order_ref");
    const channel = getChannelFromUrl();
    const reviewOrderPath = paths.ENTERPRISE_AUTOMATED_REVIEW_ORDER.replace(":channel", channel);

    const [showRetryPaymentMessage, setShowRetryPaymentMessage] = useState(
      false
    );
    const useStripePaymentForm =
      get(appSettings, "use_stripe_payment_form") || false;
    const enableOnetimePayment =
      get(appSettings, "enable_onetime_payment") || false;
    const pollPaymentStatusForSADOrder =
      get(appSettings, "poll_payment_status_for_sad_order") || false;
    const onetimePayment =
      enableOnetimePayment && get(formValues, "payment_type") === "onetime";
    const paymentReturnPath =
      channel === SELF_ACTIVATION_SIM &&
      !onetimePayment &&
      !pollPaymentStatusForSADOrder
        ? paths.SUCCESS.replace(":channel", channel)
        : paths.PAYMENT_RETURN.replace(":channel", channel);
    // const paymentReturnPath = !onetimePayment && !pollPaymentStatusForSADOrder ? paths.SUCCESS.replace(":channel", channel) : paths.ENTERPRISE_AUTOMATED_PAYMENT_RETURN.replace(":channel", channel);
    useEffect(() => {
      clearPaymentRequest();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onetimePayment]);

    useEffect(() => {
      if (
        !showRetryPaymentMessage &&
        canRequestPayment &&
        order_ref &&
        token &&
        isEmpty(paymentRequest) &&
        !isFetchingPaymentRequest
      ) {
        const return_url = `${window.location.origin}${paymentReturnPath}`;
        const failure_url = return_url;
        const cancel_url = `${window.location.origin}${reviewOrderPath}`;
        const paymentRequestParams = {
          order_id: order_ref,
          token,
          return_url,
          failure_url,
          cancel_url,
          onetime_payment: onetimePayment
        };
        setSessionToken(token);
        fetchPaymentRequest(paymentRequestParams, (response, error) => {
          if (isEmpty(response) || !!error) {
            setShowRetryPaymentMessage(true);
          }
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      token,
      isFetchingPaymentRequest,
      canRequestPayment,
      onetimePayment,
      showRetryPaymentMessage
    ]);
    const onPaymentSuccess = () => setItem("checkDvsStatus", true); // Used in AU. wont affect other countries

    const renderLegacyAdyenForm = () => {
      const verifyPayment = (order, paymentRequest, paymentResponse) => {
        const order_ref = order.order_ref || paymentRequest.order_ref;

        const payload = {
          payload: paymentResponse.payload,
          id: order.id,
          order_ref
        };
        console.log("verifyPayment for order_ref", order_ref);
        axios
          .post(paymentRequest.form_data.verify_url, payload)
          .then(response => {
            console.log("verify payment response", response);

            if (paymentResponse.resultCode === "authorised") {
              onPaymentSuccess();
              gotoUrl(paymentReturnPath, true, { order_ref, token }, true);
            } else {
              Alert.error("Payment unsuccessful please try again...");
              setTimeout(() => {
                gotoUrl(reviewOrderPath, true, {}, true);
              }, 3000);
            }
          });
      };

      return (
        <Flex mb={4} p={2}>
          <LegacyAdyenForm
            paymentRequest={paymentRequest.form_data}
            onSuccess={paymentResponse => {
              console.log("success paymentResponse", paymentResponse);
              verifyPayment(order, paymentRequest, paymentResponse);
            }}
            onFail={paymentResponse => {
              console.log("failed paymentResponse", paymentResponse);
              verifyPayment(order, paymentRequest, paymentResponse);
            }}
          />
        </Flex>
      );
    };

    const renderAdyenDropin = () => {
      const handlePaymentResponse = (paymentResponse, returnPath) => {
        const status = get(paymentResponse, "result.status");
        if (status === "SUCCESS") {
          onPaymentSuccess();
          gotoUrl(returnPath, true, { order_ref, token }, true);
        } else {
          const error = get(paymentResponse, "result.error_message");
          Alert.error(
            `${status} - ${error} - Payment unsuccessful please try again...`
          );
          setTimeout(() => {
            gotoUrl(reviewOrderPath, true, {}, true);
          }, 3000);
        }
      };
      return (
        <AdyenDropin
          paymentRequestData={paymentRequest.form_data}
          returnUrl={paymentReturnPath}
          loading={loading}
          onSuccess={(paymentResponse, returnPath) => {
            console.log("success paymentResponse", paymentResponse);
            handlePaymentResponse(paymentResponse, returnPath);
          }}
          onFail={(paymentResponse, returnPath) => {
            console.log("failed paymentResponse", paymentResponse);
            handlePaymentResponse(paymentResponse, returnPath);
          }}
        />
      );
    };

    const renderStripePayment = () => {
      const orderRef = order?.order_ref || paymentRequest?.order_ref;
      const returnPath = `${paymentReturnPath}?order_ref=${orderRef}&token=${token}`;
      return (
        <StripePaymentForm
          paymentRequest={paymentRequest}
          returnPath={returnPath}
          onPaymentSuccess={onPaymentSuccess}
          appSettings={appSettings}
        />
      );
    };

    const renderStripeCheckout = () => {
      const {
        stripe: {
          publishable_api_key,
          intent_confirmation,
          intent: { client_secret, amount }
        }
      } = get(paymentRequest, "form_data");
      const stripePromise = loadStripe(publishable_api_key);
      const orderRef = order.order_ref || paymentRequest.order_ref;
      const returnPath = `${paymentReturnPath}?order_ref=${orderRef}&token=${token}`;
      return (
        <Elements stripe={stripePromise}>
          <StripeCheckoutForm
            clientSecret={client_secret}
            intentConfirmation={intent_confirmation}
            amount={amount}
            successRedirectPath={returnPath}
            onPaymentSuccess={onPaymentSuccess}
          />
        </Elements>
      );
    };

    const renderWirecardForm = () => {
      return (
        <WirecardForm
          paymentRequest={paymentRequest}
          appSettings={appSettings}
          locale={locale}
          formValues={formValues}
        />
      );
    };

    const renderPaymentLink = label => {
      const url = get(paymentRequest, "form_data.action_object.url");
      return (
        <Box px={0} mb={10}>
          <Link rel="noopener noreferrer" href={url}>
            <Flex
              px={2}
              alignItems="center"
              width="100%"
              style={{
                backgroundColor: COLORS.blue[4],
                borderRadius: "25px",
                height: "48px",
                minWidth: "280px",
                color: "#ffffff",
                boxShadow: "0 2px 4px 0 rgb(0 0 0 / 23%)"
              }}
            >
              <Box mx={"auto"} p={"0.5rem"} pr={"0.5rem"}>
                <Text
                  fontWeight="bold"
                  fontSize={["1.2rem"]}
                  color={COLORS.white}
                >
                  <FormattedMessage id={label || "make_payment"} />
                </Text>
              </Box>
            </Flex>
          </Link>
        </Box>
      );
    };

    const renderSpinner = () => {
      return (
        <Box>
          <Spinner size={200} sx={styles.modalContainer} />
          {showRetryPaymentMessage && (
            <>
              <Text mt={3}>
                <FormattedMessage id="payment_loading_message" />
              </Text>
            </>
          )}
        </Box>
      );
    };

    const renderPaymentForm = () => {
      const { source, action, form_type, payment_session } =
        get(paymentRequest, "form_data") || {};

      if (form_type === "wirecard") {
        return renderWirecardForm();
      } else if (form_type === "stripe") {
        return useStripePaymentForm
          ? renderStripePayment()
          : renderStripeCheckout();
      } else if (form_type === "latitude") {
        return renderPaymentLink("latitude_url_title");
      } else if (source === "NPS" && action === "init_payment_form") {
        return renderAdyenDropin();
      } else if (payment_session) {
        return renderLegacyAdyenForm();
      } else {
        return renderSpinner();
      }
    };

    return (
      <Flex minHeight={"80px"} alignItems={"center"} justifyContent={"center"}>
        {loading ? renderSpinner() : renderPaymentForm()}
      </Flex>
    );
  },
  NEW_NUMBER_DISPLAY: ({ formattedSelectedNumber, data, themeColors }) => (
    <NewNumberDisplay
      {...formattedSelectedNumber}
      {...data}
      themeColors={themeColors}
    />
  ),
  NUMBER_SEARCH: NumberSearch,
  HIDE_NUMBER_SELECTION: ({ change, formValues, data, themeColors }) => {
    const hideNumberSelection = get(formValues, "hideNumberSelection");
    const label = get(data, "label", "choose_another_number");
    const primaryColor = get(themeColors, "primary") || iconThemes.blue;
    useEffect(() => {
      if (hideNumberSelection === undefined) {
        change("hideNumberSelection", true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hideNumberSelection]);
    return hideNumberSelection ? (
      <Flex
        data-testid="number-select-toggle"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        onClick={() => {
          change("hideNumberSelection", false);
        }}
        color={primaryColor}
        fontWeight="500"
        sx={{ cursor: "pointer", "& > svg": { margin: 0 } }}
      >
        <FormattedMessage id={label} />
        &nbsp;
        <PlusCircleOutline color={primaryColor} />
      </Flex>
    ) : null;
  },
  GENERAL_NUMBER_SELECTION: ({
    availableNumbers,
    selectNumber,
    formValues,
    data,
    themeColors
  }) =>
    !get(formValues, "hideNumberSelection") ? (
      <NumberSelection
        items={availableNumbers}
        onSelect={selectNumber}
        themeColors={themeColors}
        {...data}
      />
    ) : null,
  SILVER_NUMBER_SELECTION: ({
    silverNumbers,
    silverNumbersPrice,
    selectNumber,
    specialNumberAllowed,
    formValues,
    data,
    themeColors
  }) =>
    !get(formValues, "hideNumberSelection") &&
    !isEmpty(silverNumbers) &&
    specialNumberAllowed ? (
      <NumberSelection
        items={silverNumbers}
        price={silverNumbersPrice}
        onSelect={selectNumber}
        themeColors={themeColors}
        {...data}
      />
    ) : null,
  GOLDEN_NUMBER_SELECTION: ({
    goldenNumbers,
    goldenNumbersPrice,
    selectNumber,
    specialNumberAllowed,
    formValues,
    data,
    themeColors
  }) =>
    !get(formValues, "hideNumberSelection") &&
    !isEmpty(goldenNumbers) &&
    specialNumberAllowed ? (
      <NumberSelection
        items={goldenNumbers}
        price={goldenNumbersPrice}
        onSelect={selectNumber}
        themeColors={themeColors}
        {...data}
      />
    ) : null,

  ICC_ID_NRIC: ({
    iccIdPrefix,
    label,
    iccIdValid,
    iccIdError,
    required,
    resetValidateIccId,
    themeColors,
    ...props
  }) => {
    return (
      <Flex
        sx={{
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
          flexDirection: "column",
          margin: "0 auto"
        }}
      >
        {label && (
          <Flex sx={{ justifyContent: "flex-start", width: "100%" }}>
            <Label
              label={<FormattedMessage id={label} />}
              required={required}
            />
          </Flex>
        )}
        <Flex sx={{ justifyContent: "center", alignItems: "baseline" }}>
          <Text mb={8} mr={2}>
            <input
              type="text"
              readOnly
              value={iccIdPrefix}
              style={{ textAlign: "center" }}
            />
          </Text>
          <TextField
            {...props}
            onChange={() => resetValidateIccId && resetValidateIccId()}
          />
        </Flex>
        <Flex
          sx={{
            justifyContent: "center",
            alignItems: "baseline",
            width: "100%"
          }}
        >
          <TextField
            label="personal_details_nric"
            placeholder="personal_details_nric_placeholder"
            normalize={normalizerTypes.UPPERCASE({ type: "UPPERCASE" })}
            required
            field="nric"
            sx={{ width: "100%" }}
            onChange={() => resetValidateIccId && resetValidateIccId()}
          />
        </Flex>
      </Flex>
    );
  },
  ICC_ID: props => {
    const {
      iccIdPrefix,
      label,
      required,
      manualMode,
      setManualMode,
      hideInputOptions,
      setHideInputOptions,
      iccIdInUrlParam,
      iccIdValid,
      iccIdError,
      resetValidateIccId,
      resetIccIdError,
      themeColors,
      thirdParty,
      scanOnly,
      iccIdDetails,
      minimumAge,
      dateOptions,
      monthOptions,
      yearOptions,
      change,
      forceManualMode,
      nricRequired,
      formValues
    } = props;
    const redirectUrl = get(props, "data.redirectUrl");
    const genericNric = get(props, "appSettings.generic.nric");
    const showDob = includes(get(iccIdDetails, "required", []), "dob");
    const isManualMode = manualMode || forceManualMode;
    const showIccIdField =
      ((hideInputOptions || !scanOnly) &&
        !get(formValues, "icc_id") &&
        isManualMode &&
        !iccIdInUrlParam) ||
      (get(formValues, "icc_id") && !iccIdInUrlParam) ||
      showDob;
    const showScanButton =
      isManualMode && scanOnly && (!iccIdInUrlParam || iccIdError);
    const showManualButton =
      (scanOnly && isManualMode && !iccIdInUrlParam) ||
      (!isManualMode && !iccIdInUrlParam) ||
      (iccIdInUrlParam && iccIdError);
    const buttonTheme = get(themeColors, "button") || buttonThemes.blue;
    const thirdPartyTenants = get(thirdParty, "tenants", []);
    const thirdPartyTenant = get(thirdParty, "tenant", "");
    const thirdPartyOrderRefRequired = get(thirdParty, "orderRefRequired");
    const thirdPartyOrderRefRegex = get(thirdParty, "orderRefRegex");
    const thirdPartyOrderRefMaxLength = get(thirdParty, "orderRefMaxLength");
    const userNricRequired = get(thirdParty, "nricRequired") || nricRequired;
    const userNricRegex =
      get(thirdParty, "nricRegex") || get(genericNric, "validation_regex");
    const userNricMaxLength =
      get(thirdParty, "nricMaxLength") || get(genericNric, "max_length");
    const userDobRequired = get(thirdParty, "dobRequired");
    const thirdPartyValid = get(thirdParty, "valid");
    const handleDOBChange = (...args) => {
      change(...args);
      resetIccIdError && resetIccIdError();
    };
    const showBeforeInteraction =
      (!get(formValues, "icc_id") &&
        hideInputOptions &&
        scanOnly &&
        isManualMode) ||
      get(formValues, "icc_id");

    return (
      <>
        {!showBeforeInteraction && (
          <Flex
            sx={{
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "fit-content",
              margin: "auto"
            }}
          >
            {showScanButton && (
              <Button
                mx={1}
                width={[1]}
                sx={getButtonColorVariant(buttonTheme)}
                onClick={() => {
                  window.location.href = `${paths.SELF_ACTIVATION_ICCID_SCANNER}?redirect=${redirectUrl}`;
                }}
              >
                <FormattedMessage id="scan_barcode_with_camera" />
              </Button>
            )}

            {/* {showScanButton && <BarcodeScanner {...props} />} */}

            {showManualButton && (
              <Button
                mx={1}
                width={[1]}
                variant="outline"
                sx={getButtonColorVariant(buttonTheme, "link")}
                onClick={() => {
                  gotoUrl(
                    window.location.pathname,
                    true,
                    { reset: undefined, iccid: undefined },
                    false
                  );
                  resetValidateIccId && resetValidateIccId();
                  setManualMode(true);
                  setHideInputOptions(true);
                }}
              >
                <FormattedMessage id="enter_code_manually" />
              </Button>
            )}
          </Flex>
        )}
        {showIccIdField && (
          <Flex
            sx={{
              justifyContent: "center",
              alignItems: "center",
              width: "fit-content",
              flexDirection: "column",
              margin: "0 auto"
            }}
          >
            {label && (
              <Flex sx={{ justifyContent: "flex-start", width: "100%" }}>
                <Label
                  label={<FormattedMessage id={label} />}
                  required={required}
                />
              </Flex>
            )}
            <Flex
              sx={{
                justifyContent: "center",
                alignItems: "start",
                width: "324px",
                flex: 1
              }}
            >
              {iccIdPrefix && (
                <Text mb={8} mr={2}>
                  <input
                    type="text"
                    readOnly
                    value={iccIdPrefix}
                    style={{
                      textAlign: "center",
                      width: `${iccIdPrefix?.length * 10}px`
                    }}
                  />
                </Text>
              )}
              <TextField
                {...props}
                style={{ flex: 1 }}
                onChange={() => resetValidateIccId && resetValidateIccId()}
              />
            </Flex>
          </Flex>
        )}

        {iccIdInUrlParam && !showDob && (
          <Flex sx={{ justifyContent: "center", alignItems: "center" }}>
            <H1 mb={4}>{urlParam("iccid")}</H1>
          </Flex>
        )}

        {iccIdValid && (
          <Box
            sx={{
              width: "324px",
              maxWidth: "100%",
              margin: "auto"
            }}
          >
            {!isEmpty(thirdPartyTenants) && (
              <DropdownField
                label="where_did_you_purchase_the_sim"
                options={thirdPartyTenants}
                field="third_party_tenant"
                required={true}
                onChange={() => resetValidateIccId && resetValidateIccId()}
                themeColors={themeColors}
              />
            )}
            {thirdPartyOrderRefRequired && (
              <TextField
                label={`enter_your_${thirdPartyTenant}_order_number`}
                field="third_party_order_ref"
                pattern={thirdPartyOrderRefRegex}
                required={thirdPartyOrderRefRequired}
                onChange={() => resetValidateIccId && resetValidateIccId()}
                inlineValidation={{ valid: thirdPartyValid }}
                normalize={normalizerTypes.THIRD_PARTY_ORDER_REF({
                  max_length: thirdPartyOrderRefMaxLength,
                  upper_case: true
                })}
                themeColors={themeColors}
              />
            )}
            {userNricRequired && (
              <TextField
                label="personal_details_nric"
                placeholder="personal_details_nric_placeholder"
                normalize={normalizerTypes.ALPHANUMERIC_WITH_MAX_LENGTH({
                  max_length: userNricMaxLength,
                  upper_case: true
                })}
                field="nric"
                pattern={userNricRegex}
                required={userNricRequired}
                onChange={() => resetValidateIccId && resetValidateIccId()}
                inlineValidation={{ valid: thirdPartyValid }}
                themeColors={themeColors}
              />
            )}
            {userDobRequired && (
              <DateOfBirthField
                required={userDobRequired}
                label="personal_details_date_of_birth"
                minimumAge={minimumAge}
                dateOptions={dateOptions}
                monthOptions={monthOptions}
                yearOptions={yearOptions}
                change={handleDOBChange}
                themeColors={themeColors}
                {...props}
              />
            )}
          </Box>
        )}
        {showDob && (
          <Flex
            sx={{
              justifyContent: "center",
              alignItems: "baseline",
              width: "100%"
            }}
          >
            <DateOfBirthField
              required={showDob}
              minimumAge={minimumAge}
              dateOptions={dateOptions}
              monthOptions={monthOptions}
              yearOptions={yearOptions}
              change={handleDOBChange}
              themeColors={themeColors}
              {...props}
            />
          </Flex>
        )}
        {iccIdError && (
          <Flex sx={{ justifyContent: "center", alignItems: "center" }}>
            <H1 mb={4} color={themeColors?.error}>
              <FormattedMessage id={iccIdError} />
            </H1>
          </Flex>
        )}
      </>
    );
  },
  POSTAL_CODE: ({ data, postalCodeValidation, style = {}, ...props }) => {
    const field = `${get(data, "prefix")}_${props.field}`;
    const inlineValidation = get(postalCodeValidation, [field], {});
    const formValue = get(props.formValues, field);
    useEffect(() => {
      if (isFunction(props.validatePostalCode) && formValue) {
        props.validatePostalCode(formValue, field);
      }
      // eslint-disable-next-line
    }, []);
    return (
      <TextField
        {...props}
        style={style}
        inlineValidation={inlineValidation}
        field={field}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  DOI: ({ doiYearOptions, yearOptions, ...props }) => {
    const updatedProps = {
      ...props,
      yearOptions: doiYearOptions,
      field_prefix: "doi"
    };
    return <DateOfBirthField {...updatedProps} />;
  },
  DOB: props => {
    const { disabled, readOnly, formValues } = props;

    const isDisabled =
      readOnly || safeEval(get, formValues, disabled, false, props);

    return <DateOfBirthField {...props} disabled={isDisabled} />;
  },
  CONTACT_NUMBER: props => <PhoneField {...props} />,
  ALTERNATE_NUMBER: props => <PhoneField {...props} />,
  POST_PAID_NUMBER: props => <PortInNumberField {...props} />,
  PORT_IN_NUMBER: props => <PortInNumberField {...props} />,
  POST_PAID_TELCO_ACCOUNT_NUMBER: props => (
    <PortInTelcoAccountNumber {...props} />
  ),
  DOC_TYPE: ({ docTypes, data, ...props }) => {
    const options = get(docTypes, get(data, "type", "primary"), []);
    const { disabled, formValues } = props;
    const isDisabled = safeEval(get, formValues, disabled, false, props);
    return (
      <DropdownField
        options={options}
        {...props}
        onChange={constructOnChangeHandler(props)}
        disabled={isDisabled}
      />
    );
  },
  UPLOAD_ID_LATER: props => <CheckboxField {...props} />,
  BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS: props => (
    <CheckboxField {...props} />
  ),
  PRIMARY_ID_UPLOADER: ({
    frontImageUploading,
    frontImageUploaded,
    backImageUploading,
    backImageUploaded,
    uploadImage,
    appSettings,
    dropIdentityValidations,
    data,
    themeColors,
    ...props
  }) => {
    const config = get(appSettings, props.lookup, {});
    const { label, tooltip, required } = props;
    const type = get(data, "type") || "primary";
    const dropIdentityValidate = get(dropIdentityValidations, [type]);

    return (
      <>
        {label && (
          <Label
            label={<FormattedMessage id={label} />}
            tooltip={tooltip}
            required={required}
          />
        )}
        <Flex>
          {/* {config.front_image && ( */}
          <Box width={[1 / 2]} px={3}>
            <DropIdentityField
              label={config.front_image_label}
              type={type}
              frontOrBack="front"
              loading={frontImageUploading}
              onDrop={uploadImage}
              completed={frontImageUploaded}
              field={`${props.lookup}.front_image`}
              accept="image/*,application/pdf"
              validate={dropIdentityValidate}
              themeColors={themeColors}
            />
          </Box>
          {/* )} */}

          {/* {config.back_image && ( */}
          <Box width={[1 / 2]} px={3}>
            <DropIdentityField
              label={config.back_image_label}
              type={type}
              frontOrBack="back"
              loading={backImageUploading}
              onDrop={uploadImage}
              completed={backImageUploaded}
              field={`${props.lookup}.back_image`}
              accept="image/*,application/pdf"
              validate={dropIdentityValidate}
              themeColors={themeColors}
            />
          </Box>
          {/* )} */}
        </Flex>
      </>
    );
  },
  ID_UPLOADER: ({
    imageUploading,
    imageUploaded,
    uploadImage,
    appSettings,
    data,
    dropIdentityValidations,
    themeColors,
    ...props
  }) => {
    const config = get(appSettings, props.lookup, {});
    const { label, tooltip, required } = props;
    const type = get(data, "type") || "primary";
    const dropIdentityValidate = get(dropIdentityValidations, [type]);

    const accept = "image/jpeg,image/png,image/tiff,application/pdf";
    const maxSize = 8 * 1024 * 1024;

    const renderDropIdentity = side => (
      <Box width="49%" px={1}>
        <DropIdentityField
          label={get(config, `${side}_image_label`)}
          type={type}
          frontOrBack={side}
          loading={get(imageUploading, `${type}.${side}`)}
          onDrop={uploadImage}
          completed={get(imageUploaded, `${type}.${side}`)}
          field={`${props.lookup}.${side}_image`}
          testid={`${type}_${side}_image_uploader`}
          accept={accept}
          maxSize={maxSize}
          multiple={false}
          validate={dropIdentityValidate}
          themeColors={themeColors}
        />
      </Box>
    );

    return (
      <>
        {label && (
          <Label
            label={<FormattedMessage id={label} />}
            tooltip={tooltip}
            required={required}
          />
        )}
        <Label
          label={
            <FormattedMessage
              id="accepted_files_less_than_max_size"
              values={{ maxSize: `${maxSize / (1024 * 1024)} MB` }}
            />
          }
          css={{
            fontSize: "0.9rem !important",
            fontStyle: "italic",
            color: COLORS.gray[0],
            fontWeight: "normal !important"
          }}
        />
        <Flex justifyContent="space-between">
          {config.front_image && renderDropIdentity("front")}
          {config.back_image && renderDropIdentity("back")}
        </Flex>
      </>
    );
  },

  CIS_PARTNERS_FORM: props => {
    const { formFields } = props;
    return (
      <>
        {formFields.map(field => {
          return featureMapping["TEXT_FIELD"]({
            ...props,
            ...field
          });
        })}
      </>
    );
  },

  DELIVERY_ADDRESS_FORM_1: ({ formValues, fieldPrefix = "delivery" }) => {
    const selectedDeliveryMethod = get(formValues, "delivery_method", null);
    if (!selectedDeliveryMethod) return null;
    const fields = get(selectedDeliveryMethod, "fields");
    return (
      <DeliveryAddressForm1
        fields={fields}
        fieldPrefix={fieldPrefix}
        formValues={formValues}
      />
    );
  },
  DELIVERY_ADDRESS_FORM_2: ({
    formValues,
    fieldPrefix = "delivery",
    title = "personal_details_delivery_header"
  }) => {
    const selectedDeliveryMethod = get(formValues, "delivery_method", null);
    if (!selectedDeliveryMethod) return null;
    const fields = get(selectedDeliveryMethod, "fields");
    const minimize = !get(
      formValues,
      `${fieldPrefix}_show_all_address_fields`,
      false
    );

    return (
      <DeliveryAddressForm2
        title={title}
        fields={fields}
        fieldPrefix={fieldPrefix}
        minimize={minimize}
      />
    );
  },
  DELIVERY_ADDRESS_FORM_3: ({
    addressComponentMappings,
    fetchAddressComponentMappings,
    change,
    postalCodeValidation,
    setPostalCodeValidation = () => {},
    formValues,
    fieldPrefix = "delivery"
  }) => {
    const {
      allCities,
      districts,
      address_lookups,
      allDistricts
    } = addressComponentMappings;

    useEffect(
      () => {
        fetchAddressComponentMappings({});
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    const selectedDeliveryMethod = get(formValues, "delivery_method", null);
    if (!selectedDeliveryMethod) return null;
    const fields = get(selectedDeliveryMethod, "fields");

    const updateAddressFields = (foundLookup, fields) => {
      const { district_id, city_id, code } = foundLookup || {};
      const district = district_id
        ? find(allDistricts, { value: district_id })
        : null;
      const city = city_id ? find(allCities, { value: city_id }) : null;
      includes(fields, "district") &&
        change(`${fieldPrefix}_district`, district);
      includes(fields, "city") && change(`${fieldPrefix}_city`, city);
      includes(fields, "code") && change(`${fieldPrefix}_zip_code`, code);
      setPostalCodeValidation(`${fieldPrefix}_zip_code`, { status: !!code });
    };

    const onZipCodeChange = zipCode => {
      const foundLookup = find(address_lookups, lookup => {
        return zipCode.target.value === lookup.code;
      });
      updateAddressFields(foundLookup, ["district", "city"]);
    };

    const onCityChange = city => {
      const foundLookup = find(address_lookups, lookup => {
        return city.value === lookup.city_id;
      });
      updateAddressFields(foundLookup, ["code", "district"]);
    };

    const onDistrictChange = district => {
      const foundLookup = find(address_lookups, lookup => {
        return district.value === lookup.district_id;
      });
      updateAddressFields(foundLookup, ["code", "city"]);
    };

    return (
      <DeliveryAddressForm3
        fields={fields}
        fieldPrefix={fieldPrefix}
        formValues={formValues}
        cityOptions={allCities}
        districtOptions={districts}
        onZipCodeChange={onZipCodeChange}
        onCityChange={onCityChange}
        onDistrictChange={onDistrictChange}
        postalCodeValidation={postalCodeValidation}
      />
    );
  },
  DELIVERY_ADDRESS_FORM_4: ({
    addressComponentMappings,
    findAddressLookup,
    change,
    formValues,
    fieldPrefix = "delivery",
    generic,
    postalCodeValidation,
    disable_address_form,
    setPostalCodeValidation = () => {}
  }) => {
    const {
      states,
      allCities,
      allDistricts,
      villages,
      address_lookups
    } = addressComponentMappings;

    const statesCount = get(states, "length", 0);
    useEffect(() => {
      if (!statesCount) {
        findAddressLookup({});
      } else {
        const zipCode = get(formValues, `${fieldPrefix}_zip_code`);
        change(`${fieldPrefix}_street_name`, null);
        change(`${fieldPrefix}_building_name`, null);
        zipCode && onZipCodeChange({ target: { value: zipCode } }, formValues);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statesCount]);

    const selectedDeliveryMethod = get(formValues, "delivery_method", null);
    if (!selectedDeliveryMethod) return null;
    const fields = get(selectedDeliveryMethod, "fields");
    const selected_state_id = get(formValues, `${fieldPrefix}_state.value`);
    const selected_city_id = get(formValues, `${fieldPrefix}_city.value`);
    const selected_district_id = get(
      formValues,
      `${fieldPrefix}_district.value`
    );

    const resetFields = (fields = []) => {
      for (const field of fields) {
        change(`${fieldPrefix}_${field}`, null);
      }
      if (includes(fields, "zip_code")) {
        setPostalCodeValidation(`${fieldPrefix}_zip_code`, { status: false });
      }
    };

    const onStateChange = ({ value } = {}) => {
      resetFields(["zip_code", "village", "district", "city"]);
      findAddressLookup({ state_id: value });
    };

    const onCityChange = ({ value } = {}) => {
      resetFields(["zip_code", "village", "district"]);
      findAddressLookup({ city_id: value, state_id: selected_state_id });
    };

    const onDistrictChange = ({ value } = {}) => {
      resetFields(["zip_code", "village"]);
      findAddressLookup({
        district_id: value,
        city_id: selected_city_id,
        state_id: selected_state_id
      });
    };

    const onVillageChange = ({ value } = {}) => {
      const query = {
        village_id: value,
        district_id: selected_district_id,
        city_id: selected_city_id,
        state_id: selected_state_id
      };
      const { code } = find(address_lookups, query) || {};
      change(`${fieldPrefix}_zip_code`, code);
      setPostalCodeValidation(`${fieldPrefix}_zip_code`, {
        status: !isEmpty(code)
      });
    };

    const onZipCodeChange = (zipCode, prefill) => {
      const code = get(zipCode, "target.value");
      const error_message = get(generic, "zip_code.error_msg");
      const regex = get(generic, "zip_code.validation_regex");
      const maxLength = get(generic, "zip_code.max_length", 1);
      const codeValid =
        code && (regex ? code.match(regex) : code.length === maxLength);
      if (codeValid) {
        const query = { code };
        setPostalCodeValidation(
          `${fieldPrefix}_zip_code`,
          { status: false },
          true
        );
        findAddressLookup(query, (data, _) => {
          const { address_lookups, cities, districts, villages } = data;
          const foundLookup = find(address_lookups, query) || {};
          if (!isEmpty(foundLookup)) {
            const { state_id, city_id, district_id, village_id } = foundLookup;

            const villageName =
              getValueOrLabel(get(prefill, `${fieldPrefix}_village`)) ||
              last(split(get(prefill, "street_building_name"), ", "));
            const villageSelector = villageName
              ? { name: villageName }
              : { id: village_id };
            const village = mapAddressComponentOption(
              find(villages, villageSelector)
            );

            const districtName = getValueOrLabel(
              get(prefill, `${fieldPrefix}_district`)
            );
            const districtSelector = districtName
              ? { name: districtName }
              : { id: district_id };
            const district = mapAddressComponentOption(
              find(districts, districtSelector)
            );

            const cityName = getValueOrLabel(
              get(prefill, `${fieldPrefix}_city`)
            );
            const citySelector = cityName
              ? { name: cityName }
              : { id: city_id };
            const city = mapAddressComponentOption(find(cities, citySelector));

            const stateName = getValueOrLabel(
              get(prefill, `${fieldPrefix}_state`)
            );
            const stateSelector = stateName
              ? { label: stateName }
              : { value: state_id };
            const state = find(states, stateSelector);

            !isEmpty(village) && change(`${fieldPrefix}_village`, village);
            !isEmpty(district) && change(`${fieldPrefix}_district`, district);
            !isEmpty(city) && change(`${fieldPrefix}_city`, city);
            !isEmpty(state) && change(`${fieldPrefix}_state`, state);
          }
          setPostalCodeValidation(`${fieldPrefix}_zip_code`, {
            status: !isEmpty(foundLookup)
          });
        });
      } else {
        resetFields(["village", "district", "city", "state"]);
        setPostalCodeValidation(`${fieldPrefix}_zip_code`, {
          status: false,
          message: error_message
        });
      }
    };

    return (
      <DeliveryAddressForm4
        fields={fields}
        fieldPrefix={fieldPrefix}
        formValues={formValues}
        stateOptions={states}
        cityOptions={allCities}
        districtOptions={allDistricts}
        villageOptions={villages}
        onZipCodeChange={onZipCodeChange}
        onStateChange={onStateChange}
        onCityChange={onCityChange}
        onDistrictChange={onDistrictChange}
        onVillageChange={onVillageChange}
        generic={generic}
        disable={disable_address_form}
        postalCodeValidation={postalCodeValidation}
      />
    );
  },
  DELIVERY_ADDRESS_FORM_5: ({
    formValues,
    fieldPrefix = "delivery",
    linkedFieldPrefix,
    setPostalCodeValidation = () => {},
    change,
    enable
  }) => {
    const selectedDeliveryMethod = get(formValues, "delivery_method", null);
    if (!selectedDeliveryMethod || !enable) return null;
    const fields = get(selectedDeliveryMethod, "fields");
    return (
      <DeliveryAddressForm5
        fields={fields}
        fieldPrefix={fieldPrefix}
        linkedFieldPrefix={linkedFieldPrefix}
        formValues={formValues}
        change={change}
        setPostalCodeValidation={setPostalCodeValidation}
      />
    );
  },
  ADDRESS_LOOKUP: props => {
    const { formValues } = props;
    const selectedDeliveryMethod = get(formValues, "delivery_method");
    if (!selectedDeliveryMethod) return null;

    return <AddressLookup {...props} />;
  },
  BILLING_ADDRESS_FORM: props => {
    return featureMapping.DELIVERY_ADDRESS_FORM_1({
      ...props,
      fieldPrefix: "billing"
    });
  },
  BILLING_ADDRESS_FORM_2: props => {
    return featureMapping.DELIVERY_ADDRESS_FORM_2({
      ...props,
      fieldPrefix: "billing",
      title: "personal_details_billing_header"
    });
  },
  BILLING_ADDRESS_FORM_3: props => {
    return featureMapping.DELIVERY_ADDRESS_FORM_3({
      ...props,
      fieldPrefix: "billing",
      title: "personal_details_billing_header"
    });
  },
  BILLING_ADDRESS_FORM_5: props => {
    return featureMapping.DELIVERY_ADDRESS_FORM_5({
      ...props,
      fieldPrefix: "billing",
      linkedFieldPrefix: "delivery",
      title: "personal_details_billing_header"
    });
  },
  NATIONALITY_DROPDOWN: props => {
    const { disabled, formValues, topCountries } = props;

    const isDisabled = safeEval(get, formValues, disabled, false, props);

    return (
      <DropdownField
        options={topCountries}
        {...props}
        onChange={constructOnChangeHandler(props)}
        disabled={isDisabled}
      />
    );
  },
  RADIO: ({ data: { ...dataProps }, styles, ...props }) => {
    const width = get(styles, "width", [1 / 2, 1 / 3, 1 / 3]);
    return <RadioGroup {...dataProps} {...props} width={width}></RadioGroup>;
  },
  VERTICAL_RADIO: ({ data: { ...dataProps }, ...props }) => {
    return (
      <RadioGroup
        {...dataProps}
        {...props}
        options={evalProp(props, dataProps.options, [])}
        width={"100%"}
      ></RadioGroup>
    );
  },
  PREPAID_POSTPAID_RADIO: ({
    data: { ...dataProps },
    disable_on_select,
    messageData,
    ...props
  }) => {
    return (
      <RadioGroup
        width={[1 / 2, 1 / 3, 1 / 3]}
        {...dataProps}
        {...props}
        disable_on_select={disable_on_select}
        messageData={messageData}
      ></RadioGroup>
    );
  },
  NATIONALITY_RADIO: ({ topCountries, otherCountries, ...props }) => {
    const [seeMore, setToggle] = useState(false);
    const allNationalities = seeMore
      ? topCountries.concat(otherCountries)
      : topCountries;

    return (
      <RadioGroup
        options={allNationalities}
        width={[1, 1 / 3, 1 / 3]}
        {...props}
      >
        <Text
          onClick={() => setToggle(!seeMore)}
          textAlign="center"
          color="cta.color"
          sx={{
            ":hover": {
              color: "cta.hoverColor"
            }
          }}
          fontWeight="500"
          mb={6}
        >
          <FormattedMessage id={seeMore ? "see_less" : "see_more"} />
        </Text>
      </RadioGroup>
    );
  },
  TELCO_LIST_RADIO: ({ telcoList, data, ...props }) => {
    const defaultNoOfTelcosToDisplay = get(data, "display_count", 0);
    const [seeMore, setToggle] = useState(false);
    const slicedTelcos = telcoList.slice(
      0,
      seeMore === false ? defaultNoOfTelcosToDisplay : telcoList.length
    );

    return (
      <RadioGroup
        options={slicedTelcos}
        width={[1 / 2, 1 / 3, 1 / 3]}
        {...props}
      >
        <Box
          onClick={() => setToggle(!seeMore)}
          textAlign="center"
          color="cta.color"
          fontWeight="500"
          sx={{
            cursor: "pointer",
            ":hover": {
              color: "cta.hoverColor"
            }
          }}
        >
          <FormattedMessage id={seeMore ? "see_less" : "see_more"} />
        </Box>
      </RadioGroup>
    );
  },
  TELCO_LIST_DROPDOWN: ({ telcoList, onChange, ...props }) => {
    const onDropdownChange = value => {
      const change = props.change;
      const on_change = props.on_change;
      on_change &&
        // eslint-disable-next-line no-eval
        ((change, value, on_change) => eval(on_change))(
          change,
          value,
          on_change
        );
      onChange && onChange(value);
    };
    return (
      <DropdownField
        options={telcoList}
        {...props}
        onChange={onDropdownChange}
      />
    );
  },
  REGISTERED_UNDER_OWN_NRIC: ({ data, ...props }) => {
    const options = get(data, "options", []);
    return (
      <RadioGroup
        options={options}
        width={[1 / 2, 1 / 3, 1 / 3]}
        {...props}
      ></RadioGroup>
    );
  },
  ALLOWING_INCOMING_OVERSEAS_CALL: ({ data, ...props }) => {
    const options = get(data, "options", []);
    return (
      <RadioGroup
        options={options}
        width={[1 / 2, 1 / 3, 1 / 3]}
        {...props}
      ></RadioGroup>
    );
  },
  ALLOWING_INCOMING_OVERSEAS_SMS: ({ data, ...props }) => {
    const options = get(data, "options", []);
    return (
      <RadioGroup
        options={options}
        width={[1 / 2, 1 / 3, 1 / 3]}
        {...props}
      ></RadioGroup>
    );
  },
  DELIVERY_METHOD_PICKER: ({
    change,
    formValues,
    deliveryMethods,
    data,
    ...props
  }) => {
    const selectedDeliveryMethod = get(formValues, "delivery_method", {});
    const enabledDeliveryMethods = get(data, "enabled_methods", []);
    let allowedDeliveryMethods = deliveryMethods;

    if (
      isArray(enabledDeliveryMethods) &&
      enabledDeliveryMethods.length !== 0
    ) {
      const methods = [];
      deliveryMethods.forEach(m => {
        if (enabledDeliveryMethods.includes(m.action)) {
          methods.push(m);
        }
      });

      if (methods.length !== 0) {
        allowedDeliveryMethods = methods;
      }
    }

    useEffect(() => {
      if (allowedDeliveryMethods.length === 1) {
        change("delivery_method", head(allowedDeliveryMethods));
      }
      // eslint-disable-next-line
    }, []);

    return (
      allowedDeliveryMethods.length > 1 && (
        <DeliveryMethodPicker
          value={selectedDeliveryMethod.value}
          deliveryMethods={allowedDeliveryMethods}
          onSelect={deliveryMethod => {
            change("delivery_method", deliveryMethod);
          }}
          {...props}
          data={data}
        />
      )
    );
  },
  PAYMENT_METHOD_PICKER: ({ change, formValues, paymentModes }) => {
    const selectedDeliveryMethod = get(formValues, "payment_method", {});

    return (
      <DeliveryMethodPicker
        value={selectedDeliveryMethod.value}
        deliveryMethods={paymentModes}
        onSelect={paymentMode => {
          change("payment_method", paymentMode);
        }}
      />
    );
  },
  PAYMENT_METHOD_PICKER_2: ({
    change,
    handleSubmit,
    formValues,
    generic,
    field = "payment_method",
    isFetchingPaymentRequest,
    data,
    transactionDetails,
    payTodayItems,
    orderParams,
    themeColors,
    paymentsPayload = {},
    onSubmit
  }) => {
    const selectedValue = get(formValues, `${field}.value`, "");
    const paymentMethods = get(generic, "payment_methods", {});
    // Billing transaction returns amount in cents
    const transactionAmount = (get(transactionDetails, "amount") || 0) / 100;
    const payTodayAmount = get(payTodayItems, "totalAmount");
    const totalAmount = transactionAmount || payTodayAmount || 0;
    let onClick = () => {};

    const { supportedPaymentMethods } = data;
    let allowedPaymentMethods = {};

    // filter out supported payment methods from the set of paymentMethods defined in generic config
    if (!isEmpty(supportedPaymentMethods) && !isEmpty(paymentMethods)) {
      supportedPaymentMethods.forEach(method => {
        if (paymentMethods[method.name]) {
          allowedPaymentMethods[method.name] = {
            ...paymentMethods[method.name],
            /*
              method object contains the following object
              method: {
                action: <"submit" | "redirect"> // if it's a submit we are going use onSubmit action and for redirect we then check whether path key is available
                path: <url> // if the path key is available then redirect user to that path
              }
            */
            ...method
          };
        }
      });
    } else {
      allowedPaymentMethods = paymentMethods;
    }

    // Payment method picker has 2 main types, "button" and "radio". If the type is button we need to fire onSubmit action immediately.
    // If it's a radio type then we store the payment method in redux form.
    if (data.type === "button") {
      onClick = paymentMode => {
        // set the clicked payment method
        change(field, paymentMode);

        if (paymentMode?.action === "submit") {
          handleSubmit(values =>
            onSubmit(
              isEmpty(paymentsPayload) ? values : paymentsPayload,
              paymentMode
            )
          )();
        } else if (paymentMode?.action === "redirect") {
          gotoUrl(paymentMode.path);
        }
      };
    }

    return (
      <PaymentMethodPicker
        selectedValue={selectedValue}
        onClick={onClick}
        onSelect={paymentMode => {
          change(field, paymentMode);
        }}
        paymentMethods={allowedPaymentMethods}
        isFetchingPaymentRequest={isFetchingPaymentRequest}
        themeColors={themeColors}
        payTodayItems={payTodayItems}
        transactionDetails={transactionDetails}
        totalAmount={totalAmount}
        formValues={formValues}
        orderParams={orderParams}
        {...data}
      />
    );
  },
  PAYMENT_QR_VIEWER: ({
    order,
    payTodayItems,
    paymentRequest,
    data,
    themeColors
  }) => {
    const {
      completedPaymentButton,
      qrCodePageHeader,
      qrCodeSteps,
      qrPaymentLabel
    } = data || {};

    const payNowPrice = get(payTodayItems, "totalPrice");
    const { qrCodeUrl } = getGopayActionUrls(paymentRequest) || {
      qrCodeUrl: "placeholder-url"
    };
    const orderRef = get(order, "order_ref", "");
    const channel = getChannelFromUrl();
    const origin = window.location.origin;
    const statusPath = paths.PAYMENT_STATUS.replace(":channel", channel);
    const statusUrl = `${origin}${statusPath}?order_ref=${orderRef}`;

    return (
      <>
        <Box textAlign="center">
          <H2 mb={5} color={COLORS.gray[3]}>
            <FormattedMessage id={qrCodePageHeader} />
          </H2>
          {map(qrCodeSteps, (step, index) => (
            <H3 key={`step-${index}`} mb={15} color={themeColors.primary}>
              <Text as="span" pr={1} color={themeColors.primary}>
                {index + 1}.
              </Text>
              <FormattedMessage id={step} />
            </H3>
          ))}
        </Box>
        <Flex
          mx="auto"
          sx={{
            border: "7px solid",
            borderColor: themeColors.primary,
            borderRadius: "10px 10px 0px 0px",
            width: "280px",
            height: "280px"
          }}
        >
          <img src={qrCodeUrl} width="280px" height="280px" alt="QR Code" />
        </Flex>
        <Flex
          justifyContent="space-between"
          mx="auto"
          sx={{
            p: "6px",
            border: "7px solid",
            borderColor: themeColors.primary,
            borderRadius: "0px 0px 10px 10px",
            width: "280px",
            backgroundColor: themeColors.primary
          }}
        >
          <H3 color={COLORS.white} mr={40}>
            <FormattedMessage id={qrPaymentLabel} />
          </H3>
          <H3 color={COLORS.white} minWidth="90px">
            {payNowPrice}
          </H3>
        </Flex>
        <Flex justifyContent="center">
          <Button
            my={30}
            minWidth={[1 / 2, 1 / 3, 1 / 3]}
            sx={getButtonColorVariant(themeColors.button)}
            onClick={() => {
              window.location.href = statusUrl;
            }}
          >
            <FormattedMessage id={completedPaymentButton} />
          </Button>
        </Flex>
      </>
    );
  },
  GOOGLE_PREDICT_FIELD: ({
    change,
    formValues,
    type = "delivery",
    validatePostalCode,
    data,
    ...props
  }) => {
    const selectedDeliveryMethod = get(formValues, "delivery_method", {});
    if (!selectedDeliveryMethod.google_predict) return null;
    const skipValidatePostalCode = get(data, "skipValidatePostalCode");
    const validatePostalCodeMethod = !skipValidatePostalCode
      ? validatePostalCode
      : () => {};
    return (
      <LocationField
        onSelect={address => {
          change(props.field, address);
          setAddress(change, type, address, validatePostalCodeMethod, data);
        }}
        onError={() => {
          change(
            `${type}_location_error`,
            "click_here_to_fill_in_your_address_manually"
          );
          resetAddressFields(change, type, [`${type}_location`]);
        }}
        {...props}
      />
    );
  },
  ADDRESS_ERROR_HANDLER: ({ change, formValues, type = "delivery" }) => {
    const field = `${type}_location_error`;
    const id = get(formValues, field) || "";
    return !id ? null : (
      <Field
        name={field}
        change={change}
        msg={id}
        component={({ change, msg }) => (
          <Text
            mt={[-4]}
            mb={4}
            size="xs"
            color={COLORS.red[1]}
            sx={{ cursor: "pointer", width: "fit-content" }}
            onClick={() => change(`${type}_show_all_address_fields`, true)}
          >
            <FormattedMessage id={msg} />
          </Text>
        )}
      />
    );
  },

  DELIVERY_DATE_PICKER: ({
    change,
    formValues,
    combinedDeliverySlotDates,
    deliverySlotDates,
    selectedNumber,
    fetchDeliverySlots,
    resetDeliverySlots,
    skipPostalCodeValidation = false,
    postalCodeValidation,
    data = {},
    phoneVariant,
    isFetchingDeliverySlots,
    changeField,
    generic,
    ...props
  }) => {
    const deliveryZipCode = get(formValues, "delivery_zip_code");
    const selectedDeliveryMethod = get(formValues, "delivery_method", {});
    const deliveryZipCodeValid =
      skipPostalCodeValidation ||
      get(data, "skip_postal_code_validation", false) ||
      get(postalCodeValidation, "delivery_zip_code.valid", false);
    const selectedHomeDelivery = selectedDeliveryMethod.action === "home";
    const selectedPhoneSku = get(phoneVariant, "sku");
    const combinedSlots = data.combined;
    const courier = get(data, "courier", null);
    const autoSelectDeliverySlots = get(data, "auto_select_delivery_slots");
    const showAutoSelectedDeliverySlots = get(
      data,
      "show_auto_selected_delivery_slots"
    );
    const phoneOnly = getChannelFromUrl() === PHONE_ONLY_CHANNEL;
    const combo = getChannelFromUrl() === COMBO_CHANNEL;
    const esim = get(props, "preCheckoutData.sim_type") === "esim";
    const esim_combo = esim && combo;

    let slotType;
    if (phoneOnly || esim_combo) {
      slotType = DELIVERY_SLOT_TYPE_PHONE;
    } else if (combo) {
      slotType = DELIVERY_SLOT_TYPE_SIM_AND_PHONE;
    } else {
      slotType =
        props.orderItemType ||
        replace(props.orderType, /_/g, "-") ||
        DELIVERY_SLOT_TYPE_SIM;
    }

    if (!combinedSlots) {
      deliverySlotDates = uniqBy(deliverySlotDates, "label").map(item => {
        return {
          ...item,
          value: item.date,
          description: null,
          cost: null,
          formattedCost: null
        };
      });
    }

    const slots = combinedSlots ? combinedDeliverySlotDates : deliverySlotDates;
    const field = combinedSlots ? "delivery_slot_full_data" : "delivery_date";
    const number = get(selectedNumber, "number");
    const orderChannelSlots = get(generic, "order_channel_slots", false);
    const channelName = getChannelFromUrl();
    const channel = orderChannelSlots
      ? get(ORDER_CHANNEL_MAPPING, channelName, WEBSITE_V2)
      : channelName;
    useEffect(
      () => {
        if (deliveryZipCodeValid && deliveryZipCode && selectedHomeDelivery) {
          fetchDeliverySlots(
            {
              channel,
              postal_code: deliveryZipCode,
              identifier:
                phoneOnly || combo ? selectedPhoneSku : deliveryZipCode,
              number,
              portin: false,
              type: slotType,
              courier
            },
            () => {
              // clear the selected slot if the zip-code is changed
              changeField("delivery_slot_full_data", null);
            }
          );
        } else {
          !isEmpty(slots) && resetDeliverySlots();
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [deliveryZipCodeValid, deliveryZipCode, selectedHomeDelivery]
    );

    useEffect(() => {
      if (autoSelectDeliverySlots && !isEmpty(slots)) {
        change("delivery_slot_full_data", head(slots).value);
        change("delivery_slot_fee", head(slots).cost);
        change("delivery_slot_id", head(slots).slotId);
        change("delivery_slot", head(slots).deliverySlot);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slots]);

    return selectedHomeDelivery &&
      (!autoSelectDeliverySlots || showAutoSelectedDeliverySlots) ? (
      <DeliverySlotGroup
        change={change}
        options={slots}
        isLoading={isFetchingDeliverySlots}
        {...props}
        {...data}
        field={field}
      />
    ) : null;
  },
  // SIMPLE_DATE_PICKER: ({ change, deliverySlotDates, ...props }) => {
  //   return <DeliverySlotGroup options={deliverySlotDates} {...props} />;
  // },
  FREE_DELIVERY_SLOT_PICKER: ({
    change,
    formValues,
    freeDeliverySlotTime,
    data = {},
    ...props
  }) => {
    const deliveryDate = get(formValues, "delivery_date");

    return deliveryDate && !props.isFetchingDeliverySlots ? (
      <DeliverySlotGroup
        change={change}
        options={freeDeliverySlotTime}
        {...props}
        {...data}
      />
    ) : null;
  },
  SPECIAL_DELIVERY_SLOT_PICKER: ({
    change,
    formValues,
    specialDeliverySlotTime,
    data = {},
    ...props
  }) => {
    const deliveryDate = get(formValues, "delivery_date");

    return deliveryDate && !props.isFetchingDeliverySlots ? (
      <DeliverySlotGroup
        change={change}
        options={specialDeliverySlotTime}
        {...props}
        {...data}
      />
    ) : null;
  },
  STORE_PICKER_1: ({
    change,
    fetchPostOfficeDeliverySlots,
    postOfficeDeliverySlots,
    postOfficeRegions,
    selectedNumber,
    selectedPostOffice,
    themeColors
  }) => {
    useEffect(
      () => {
        if (selectedPostOffice)
          setPostOfficeAddressAsDeliveryAddress(change, selectedPostOffice);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [selectedPostOffice]
    );

    return (
      <PostOfficePickUp
        regions={postOfficeRegions}
        selectedNumber={selectedNumber}
        fetchPostOfficeDeliverySlots={fetchPostOfficeDeliverySlots}
        onRegionChange={({ value }) => {
          const params = {
            portin: false,
            selectedRegion: value,
            type: "sim-only"
          };
          fetchPostOfficeDeliverySlots(params);
        }}
        deliverySlots={postOfficeDeliverySlots}
        themeColors={themeColors}
      />
    );
  },
  STORE_PICKER_2: ({
    cityList,
    districtList,
    streetList,
    storeList,
    fetchCityList,
    fetchDistrictList,
    fetchStreetList,
    fetchStoreList,
    resetDistrictList,
    resetStreetList,
    resetStoreList,
    formValues,
    changeField,
    change,
    data,
    themeColors
  }) => {
    useEffect(() => {
      if (!cityList.length) {
        fetchCityList();
      }
      // eslint-disable-next-line
    }, [cityList]);
    const CITY_FIELD = "delivery_city_id";
    const DISTRICT_FIELD = "delivery_district_id";
    const STREET_FIELD = "delivery_street_id";
    const STORE_FIELD = "post_office_id";
    const showMap = get(data, "showMap");

    const constructOptions = data =>
      map(data, option => {
        return {
          label: option.value,
          value: option.id
        };
      });

    const constructStoreOptions = data =>
      map(data, option => {
        return {
          ...option,
          label: <PostOfficeCard {...option} showMap={showMap} />,
          value: option.id
        };
      });

    const changeHandler = {
      [CITY_FIELD]: value => {
        const fieldValue = formValues[CITY_FIELD];
        changeField(DISTRICT_FIELD);
        changeField(STREET_FIELD);
        changeField(STORE_FIELD);
        resetDistrictList();
        resetStreetList();
        resetStoreList();
        if (value === fieldValue) {
          setTimeout(() => changeField(CITY_FIELD), 0);
        } else {
          changeField(CITY_FIELD, value);
          const params = {
            city: value
          };
          fetchDistrictList(params);
        }
      },
      [DISTRICT_FIELD]: value => {
        const fieldValue = formValues[DISTRICT_FIELD];
        changeField(STREET_FIELD);
        changeField(STORE_FIELD);
        resetStreetList();
        resetStoreList();
        if (value === fieldValue) {
          setTimeout(() => changeField(DISTRICT_FIELD), 0);
        } else {
          changeField(DISTRICT_FIELD, value);
          const params = {
            city: formValues[CITY_FIELD],
            district: value
          };
          fetchStreetList(params);
        }
      },
      [STREET_FIELD]: value => {
        const fieldValue = formValues[STREET_FIELD];
        changeField(STORE_FIELD);
        resetStoreList();
        if (value === fieldValue) {
          setTimeout(() => changeField(STREET_FIELD), 0);
        } else {
          changeField(STREET_FIELD, value);
          const params = {
            city: formValues[CITY_FIELD],
            district: formValues[DISTRICT_FIELD],
            street: value
          };
          fetchStoreList(params);
        }
      },
      [STORE_FIELD]: value => {
        const fieldValue = formValues[STORE_FIELD];
        if (value === fieldValue) {
          setTimeout(() => changeField(STORE_FIELD), 0);
        } else {
          changeField(STORE_FIELD, value);
          const selectedStore = find(storeList, ["id", value]);
          !isEmpty(selectedStore) &&
            setPostOfficeAddressAsDeliveryAddress(change, selectedStore);
        }
      }
    };

    const renderRadioGroup = (options, field, label, singleOptionRow) => {
      const fieldValue = formValues[field];
      const fieldOptions = fieldValue
        ? filter(options, ["value", fieldValue])
        : options;
      return isEmpty(options) ? null : (
        <RadioButtonGroup
          required
          options={fieldOptions}
          onChange={changeHandler[field]}
          field={field}
          label={fieldValue ? "" : label}
          singleOptionRow={singleOptionRow || !!fieldValue}
          themeColors={themeColors}
        />
      );
    };

    return (
      <>
        {renderRadioGroup(
          constructOptions(cityList),
          CITY_FIELD,
          "delivery_info_choose_city"
        )}
        {renderRadioGroup(
          constructOptions(districtList),
          DISTRICT_FIELD,
          "delivery_info_choose_district"
        )}
        {renderRadioGroup(
          constructOptions(streetList),
          STREET_FIELD,
          "delivery_info_choose_street"
        )}
        {renderRadioGroup(
          constructStoreOptions(storeList),
          STORE_FIELD,
          "delivery_info_choose_store",
          true
        )}
      </>
    );
  },
  SMART_MODAL: props => {
    let {
      styles,
      pageProps,
      appSettings,
      screenshotEnabled,
      components: pageComponents,
      modalStyles
    } = props;
    const modalStyleOverride = modalStyles
      ? modalStyles.modalStyle
      : styles?.modalStyle;
    const overrideOverlayStyle = modalStyleOverride?.overlay || {};
    const overrideContentStyle = modalStyleOverride?.content || {};
    const defaultOverlayStyle = {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.70)",
      zIndex: 2000
    };
    const defaultContentStyle = {
      position: "absolute",
      border: "1px solid #ccc",
      background: "white",
      overflow: "hidden",
      borderRadius: "12px",
      outline: "none",
      padding: "10px",
      maxWidth: "570px",
      maxHeight: "570px",
      margin: "auto",
      inset: "1rem",
      minHeight: "fit-content"
    };

    const modalStyle = {
      overlay: { ...defaultOverlayStyle, ...overrideOverlayStyle },
      content: { ...defaultContentStyle, ...overrideContentStyle }
    };
    return (
      <>
        <ReactModal style={modalStyle} isOpen={true}>
          <div data-testid="smart-render">
            <Box style={{ padding: "30px" }}>
              {isEmpty(pageComponents) ? (
                <Flex mt={3} justifyContent="center">
                  <Spinner size={200} sx={styles.fullPage} />
                </Flex>
              ) : (
                renderPageComponents({
                  pageComponents,
                  pageProps,
                  appSettings,
                  screenshotEnabled
                })
              )}
            </Box>
          </div>
        </ReactModal>
      </>
    );
  },

  POP_STATION_PICKER: ({
    change,
    changeField,
    formValues,
    postalCodeValidation,
    fetchPopStations,
    themeColors,
    data,
    popStationsDeliverySlots,
    isFetchingPopStations,
    ...props
  }) => {
    const deliveryInfoVariant = get(data, "variant");
    const prefix = "pop_station";

    const deliveryZipCode = get(formValues, "pop_station_zip_code");
    const selectedDeliveryMethod = get(formValues, "delivery_method", {});
    const deliveryZipCodeValid = get(
      postalCodeValidation,
      "pop_station_zip_code.valid",
      false
    );
    const selectedPopStation = selectedDeliveryMethod.action === "pop_station";
    const validationRegex = RegExp(/^[\d]{6}$/);

    const deliverySlot = get(
      popStationsDeliverySlots.slice().sort((a, b) => a.cost - b.cost),
      "0",
      {}
    );

    const updateFormValues = data => {
      const unit_no = get(data, "unit_number");
      const street_name = get(data, "street_name");
      const building_name = get(data, "building_name");
      const hse_blk_tower = get(data, "house_block_number");
      const city = get(data, "city");
      const state = get(data, "state");
      const country = get(data, "country");
      const deliverySlotCost = get(deliverySlot, "cost", 0);

      changeField(`${prefix}_unit_no`, unit_no);
      changeField(`${prefix}_street_name`, street_name);
      changeField(`${prefix}_building_name`, building_name);
      changeField(`${prefix}_hse_blk_tower`, hse_blk_tower);
      changeField(`${prefix}_city`, city); // Need to check
      changeField(`${prefix}_state`, state); // Need to check
      changeField(`${prefix}_country`, country);

      changeField(`${prefix}_slot_full_data`, deliverySlot.date_time);
      changeField(`${prefix}_slot_id`, deliverySlot.id);
      changeField(`${prefix}_slot`, deliverySlot.courier_slot_name);
      changeField(`${prefix}_outlet_full_data`, data);

      if (deliverySlotCost > 0) {
        changeField(`${prefix}_slot_fee`, deliverySlotCost);
      }
    };

    useEffect(() => {
      if (isFetchingPopStations) {
        change("pop_station_outlet_full_data", {});
        resetAddressFields(change, prefix, [
          `${prefix}_zip_code`,
          `${prefix}_location`
        ]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetchingPopStations]);

    useEffect(() => {
      return () => {
        resetAddressFields(change, prefix, [
          `${prefix}_zip_code`,
          `${prefix}_location`,
          "pop_station_outlet_full_data"
        ]);
        changeField(`${prefix}_slot_fee`, 0);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(
      () => {
        //temp solution

        if (
          deliveryZipCodeValid &&
          validationRegex.test(deliveryZipCode) &&
          selectedPopStation
        ) {
          fetchPopStations({ postal_code: deliveryZipCode });
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [deliveryZipCodeValid, deliveryZipCode, selectedPopStation]
    );

    return (
      <PopStationBox
        {...props}
        {...data}
        formValues={formValues}
        themeColors={themeColors}
        deliveryInfoVariant={deliveryInfoVariant}
        popStations={props.popStations}
        popStationsDeliverySlots={popStationsDeliverySlots}
        isFetchingPopStations={isFetchingPopStations}
        updateFormValues={updateFormValues}
      ></PopStationBox>
    );
  },

  SELF_ACTIVATION_DELIVERY_MODAL: props => {
    let {
      styles,
      pageProps,
      appSettings,
      screenshotEnabled,
      components: pageComponents,
      padding,
      width,
      themeColors
    } = props;
    if (isPlainObject(styles?.modalStyle?.content)) {
      const borderColor =
        get(themeColors, "card") ||
        get(themeColors, "primary", iconThemes.blue);
      const styleOverrides = !isMobile()
        ? {
            padding,
            width
          }
        : {};
      styles.modalStyle.content = {
        ...styles.modalStyle.content,
        borderColor,
        ...styleOverrides
      };
    }
    return (
      <>
        <ReactModal style={styles.modalStyle} isOpen={true}>
          <div data-testid="smart-render">
            <Box>
              {isEmpty(pageComponents) ? (
                <Flex mt={3} justifyContent="center">
                  <Spinner size={200} sx={styles.fullPage} />
                </Flex>
              ) : (
                renderPageComponents({
                  pageComponents,
                  pageProps,
                  appSettings,
                  screenshotEnabled
                })
              )}
            </Box>
          </div>
        </ReactModal>
      </>
    );
  },
  SIM_REPLACEMENT_MODAL: props => {
    const [showModal, setShowModal] = useState(false);

    const { styles, data, handleSubmit, payload, onSubmit, invalid } = props;
    const simType =
      get(props, "formValues.replacement_sim_type.value")?.toLowerCase() || "";
    const prefix = "order_action_sim_replacement_confirm";
    const title = data?.title || `${prefix}_title_${simType}`;
    const message = data?.message || `${prefix}_message_${simType}`;
    const defaultNextPath = `${window.location.pathname}/success`;
    const nextPath = data?.nextPagePath || defaultNextPath;
    const prevPath = data?.prevPagePath || paths.MANAGE_ORDER;
    const free5GUpgrade = data?.free5GUpgrade;
    const invalidButton = free5GUpgrade
      ? isEmpty(get(props, "selectedMobileDevice")) ||
        !get(props, "selectedMobileDevice[5g]") ||
        (get(props.formValues, "sim_type") === "esim" &&
          !get(props, "selectedMobileDevice.esim"))
      : invalid;
    const navigate = isFunction(props?.navigate)
      ? props?.navigate
      : () => gotoUrl(nextPath);

    const submit = _ => {
      onSubmit(navigate, payload);
    };

    return (
      <>
        <Flex justifyContent="space-between">
          <Button variant="outline" onClick={() => gotoUrl(prevPath)}>
            <FormattedMessage id="go_back" />
          </Button>
          <Button
            onClick={() => (free5GUpgrade ? submit() : setShowModal(true))}
            disabled={invalidButton}
          >
            <FormattedMessage id="submit" />
          </Button>
        </Flex>

        <ReactModal style={styles.modalStyle} isOpen={showModal}>
          <Box mb={8}>
            <FormattedMessage id={title}>
              {msg => <H1>{msg}</H1>}
            </FormattedMessage>
          </Box>
          <Box mb={8}>
            <FormattedMessage html id={message}></FormattedMessage>
          </Box>
          <Flex justifyContent="space-between">
            <Button variant="outline" onClick={() => setShowModal(false)}>
              <FormattedMessage id="cancel" />
            </Button>
            <Button onClick={handleSubmit(submit)}>
              <FormattedMessage id="confirm" />
            </Button>
          </Flex>
        </ReactModal>
      </>
    );
  },
  SCHEDULE_NUMBER_CHANGE_MODAL: props => {
    const [showModal, setShowModal] = useState(false);

    const {
      styles,
      handleSubmit,
      submitNumberChange,
      orderRef,
      selectedNumber,
      oldPhoneNumber,
      invalid
    } = props;

    const submit = values => {
      submitNumberChange({
        orderRef,
        selectedNumber,
        oldPhoneNumber,
        ...values
      });
    };

    return (
      <>
        <Flex justifyContent="center">
          <FormattedMessage id="order_action_change_number_schedule_number_change">
            {msg => (
              <Button onClick={() => setShowModal(true)} disabled={invalid}>
                {msg}
              </Button>
            )}
          </FormattedMessage>
        </Flex>

        <ReactModal style={styles.modalStyle} isOpen={showModal}>
          <Box mb={8}>
            <FormattedMessage id="order_action_change_number_please_confirm_change_number">
              {msg => <H1>{msg}</H1>}
            </FormattedMessage>
          </Box>

          <Box>
            <FormattedMessage
              id="order_action_change_number_old_phone_number_to_new_phone_number"
              values={{ oldPhoneNumber, newPhoneNumber: selectedNumber }}
            />
          </Box>

          <Flex justifyContent="center">
            <Button onClick={handleSubmit(submit)}>
              <FormattedMessage id="confirm" />
            </Button>
          </Flex>
        </ReactModal>
      </>
    );
  },
  SUSPENSION_START_DATE: props => {
    const { change, suspensionStartDates } = props;

    return (
      <DropdownField
        options={suspensionStartDates}
        {...props}
        onChange={() => {
          change("suspension_end_date", undefined);
        }}
      />
    );
  },
  SUSPENSION_END_DATE: props => {
    const { suspensionEndDates } = props;

    return (
      <DropdownField
        options={suspensionEndDates}
        {...props}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  REQUEST_SUSPENSION_MODAL: props => {
    const {
      styles,
      handleSubmit,
      invalid,
      showCardChargePrompt,
      suspensionPhoneNumber,
      selectedSuspensionStartDate,
      selectedSuspensionEndDate,
      suspensionPaymentDetails,
      submitSuspension,
      suspensionPricePerMonth,
      orderRef,
      fetchSuspensionPaymentDetails
    } = props;

    const [showModal, setShowModal] = useState(false);

    useEffect(
      () => {
        if (selectedSuspensionStartDate && selectedSuspensionEndDate) {
          fetchSuspensionPaymentDetails({
            startDate: selectedSuspensionStartDate,
            endDate: selectedSuspensionEndDate,
            amount: suspensionPricePerMonth
          });
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [selectedSuspensionStartDate, selectedSuspensionEndDate]
    );

    const submit = values => {
      submitSuspension({
        orderRef,
        suspensionPhoneNumber,
        suspensionPricePerMonth,
        ...values,
        ...suspensionPaymentDetails
      });
    };

    const cardNetwork = get(suspensionPaymentDetails, "card_network", "");
    const cardNumber = get(suspensionPaymentDetails, "card_number", "");
    const chargeableAmount = get(suspensionPaymentDetails, "amount", "");

    return (
      <>
        {showCardChargePrompt && (
          <>
            <FormattedMessage
              id="order_action_suspend_number_your_card_will_be_charged"
              values={{
                cardNetwork,
                cardNumber,
                chargeableAmount
              }}
            >
              {msg => (
                <Text mb={8}>
                  {msg}
                  &nbsp;
                  <FormattedMessage id="order_action_suspend_number_you_will_not_be_billed_for_duration_of_suspension" />
                </Text>
              )}
            </FormattedMessage>
          </>
        )}

        <Flex justifyContent="center">
          <FormattedMessage id="order_action_suspend_number_submit_suspension">
            {msg => (
              <Button onClick={() => setShowModal(true)} disabled={invalid}>
                {msg}
              </Button>
            )}
          </FormattedMessage>
        </Flex>

        <ReactModal style={styles.modalStyle} isOpen={showModal}>
          <Box>
            <Box mb={8}>
              <FormattedMessage id="order_action_suspend_number_request_temporary_suspension">
                {msg => <H1>{msg}</H1>}
              </FormattedMessage>
            </Box>

            <Box>
              <FormattedMessage
                id="order_action_suspend_number_on_clicking_confirm"
                values={{
                  suspensionPhoneNumber,
                  suspensionStartDate: moment(
                    selectedSuspensionStartDate
                  ).format("DD MMMM YYYY"),
                  suspensionEndDate: moment(selectedSuspensionEndDate).format(
                    "DD MMMM YYYY"
                  ),
                  chargeableAmount
                }}
              >
                {msg => <Text>{msg}</Text>}
              </FormattedMessage>
            </Box>
          </Box>

          <Flex justifyContent="center" padding="1rem">
            <Button onClick={handleSubmit(submit)}>
              <FormattedMessage id="confirm" />
            </Button>
            <Button onClick={() => setShowModal(false)} variant="outline">
              <FormattedMessage id="cancel" />
            </Button>
          </Flex>
        </ReactModal>
      </>
    );
  },
  TEXTAREA_FIELD: props => <TextAreaField {...props} />,
  ACYEN_STORE_PICKER: props => <AcyenStorePicker {...props} />,
  TERMINATION_REASON: ({ orderDetails, data, ...props }) => {
    const terminationReasons = get(orderDetails, "terminationReasons", []);
    return (
      <DropdownField
        options={terminationReasons}
        {...props}
        {...data}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  DELIVERY_FAIL_REASON: ({ scheduleDeliveryDetails, data, ...props }) => {
    const { title, subtitle, placeholder } = data || {};
    const selectedLabel = get(props, "formValues.fail_reason.label");
    const failureReasons = get(
      scheduleDeliveryDetails,
      "failure_reasons",
      []
    ).map(item => {
      return {
        label: item.name,
        value: item.value
      };
    });

    // remove the select a reason coming from the api
    failureReasons.splice(0, 1);
    const filterReasons = failureReasons.filter(
      item => selectedLabel !== item.label
    );

    return (
      <>
        <DropdownField
          placeholder={placeholder}
          label={title}
          options={filterReasons}
          field="fail_reason"
          required={true}
          onChange={constructOnChangeHandler(props)}
        />
        {subtitle && (
          <Text size="sm" mt={-5} mb={5}>
            <FormattedMessage html id={subtitle} />
          </Text>
        )}
      </>
    );
  },
  TERMINATION_DATE: ({ orderDetails, data, ...props }) => {
    const terminationDates = get(orderDetails, "terminationDates", []);
    return (
      <DropdownField
        options={terminationDates}
        {...props}
        {...data}
        onChange={constructOnChangeHandler(props)}
      />
    );
  },
  TERMS_AND_CONDITIONS: ({ data, checkboxStyles, ...props }) => {
    const { linkUrl, linkText, styles } = data || {};
    const style = styles || { color: COLORS.blue[4] };
    return (
      <Box px={0} mb={3}>
        {linkUrl && linkText && (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={linkUrl}
            sx={style}
          >
            <FormattedMessage id={linkText} />
          </Link>
        )}
        <CheckboxField sx={checkboxStyles} {...props} />
      </Box>
    );
  },
  SCROLLABLE_SECTION: ({ label, message, ...props }) => {
    const scrollToBottomCheck = event => {
      if (!props.consentReviewed) return;

      const { scrollHeight, scrollTop, clientHeight } = event.target;
      const margin = 100;
      const bottomReached = scrollHeight - scrollTop < clientHeight + margin;

      // debug log to check the function in different browser versions
      console.debug("scrollToBottomCheck", {
        scrollHeight,
        scrollTop,
        clientHeight,
        rest: event.target
      });

      if (bottomReached) {
        props.consentReviewed();
      }
    };
    return (
      <Box mb={3}>
        <Box mb={3}>
          <Text fontWeight="700" fontSize="1rem">
            <FormattedMessage id={label} html />
          </Text>
        </Box>
        <Box
          p={1}
          maxHeight="15rem"
          mb={3}
          mt="1rem"
          overflowX="scroll"
          sx={{ border: "1px solid #999999" }}
          onScroll={scrollToBottomCheck}
        >
          <Text fontSize="0.9rem">
            <FormattedMessage id={message} html />
          </Text>
        </Box>
      </Box>
    );
  },
  ESIGN_FIELD: props => <ESignField {...props} />,
  REQUEST_TERMINATION_MODAL: props => {
    const [showModal, setShowModal] = useState(props.showModal);

    const {
      styles,
      handleSubmit,
      submitTermination,
      submitWinback,
      dismissTermination,
      orderId,
      orderRef,
      actionType,
      orderDetails: { terminationPhoneNumber },
      termination: {
        terminationFeedback,
        terminationReason,
        terminationDate,
        winbackId,
        winbackCode,
        winbackOffer,
        selectedWinback
      },
      data
    } = props;

    const title = get(data, "title", "Terminate Number");
    const submitLabel = get(data, "submit.label", "Submit");
    const cancelLabel = get(data, "cancel.label", "Cancel");
    const winbackEnabled =
      get(data, "winback.enable", false) && !isEmpty(selectedWinback);
    const winbackMessage = winbackEnabled && get(data, "winback.message", "");
    const winbackBanner = winbackEnabled && get(data, "winback.banner", "");
    const successPath = get(data, "submit.path", "");
    const winbackPath = get(data, "winback.path", "");
    const dismissPath = get(data, "dismiss.path", "");

    const submit = () => {
      submitTermination({
        orderRef,
        actionType,
        terminationFeedback,
        terminationReason,
        terminationDate,
        successPath
      });
    };

    const cancel = () => {
      winbackEnabled && submitWinback && winbackId
        ? submitWinback({
            orderId,
            orderRef,
            winbackId,
            winbackCode,
            winbackOffer,
            terminationPhoneNumber,
            terminationFeedback,
            terminationReason,
            terminationDate,
            winbackPath
          })
        : (() => {
            setShowModal(false);
            dismissTermination(dismissPath);
          })();
    };

    const onNextClick = (() => {
      // check if winback is eligible
      if (!(winbackEnabled && submitWinback && winbackId)) {
        return handleSubmit(() => submit());
      }

      return handleSubmit
        ? handleSubmit(() => setShowModal(true))
        : setShowModal(true);
    })();

    return (
      <>
        <PageNavigation onNextClick={onNextClick} {...data} />
        <ReactModal style={styles.modalStyle} isOpen={showModal}>
          <Box mb={8}>
            <FormattedMessage id={title}>
              {msg => <H1>{msg}</H1>}
            </FormattedMessage>
          </Box>

          {winbackBanner && (
            <>
              <Flex justifyContent="space-evenly">
                <img
                  style={{ width: "auto", height: "300px" }}
                  src={winbackBanner}
                  alt="winback-banner"
                />
              </Flex>
              <br />
            </>
          )}

          {winbackMessage && (
            <>
              <Box width={9 / 10} mx="auto">
                <FormattedMessage
                  id={winbackMessage}
                  values={{ winbackOffer }}
                  html
                />
              </Box>
              <br />
            </>
          )}

          <Flex justifyContent="space-evenly">
            <Button onClick={cancel} variant="outline">
              <FormattedMessage id={cancelLabel} />
            </Button>
            <Button onClick={submit}>
              <FormattedMessage id={submitLabel} />
            </Button>
          </Flex>
        </ReactModal>
      </>
    );
  },
  TERMINATION_STATUS: props => {
    const {
      manageAnotherOrder,
      reset,
      data,
      messageData,
      termination: { winbackOffer }
    } = props;
    const { title, banner, path, message } = data || {};
    return (
      <>
        <Box>
          <PageHeader title={title} />
          <Box>
            {banner && (
              <Flex justifyContent="space-evenly">
                <img
                  width="auto"
                  height="auto"
                  margin="0 auto"
                  src={banner}
                  alt="termination-status-banner"
                />
              </Flex>
            )}

            {message && (
              <>
                <Flex justifyContent="space-evenly">
                  <FormattedMessage
                    id={message}
                    values={{ ...messageData, winbackOffer }}
                    html
                  />
                </Flex>
                <br />
              </>
            )}
          </Box>
        </Box>
        <Flex justifyContent="space-evenly" padding="1rem">
          <Button
            as="a"
            href={path || MANAGE_ORDER_URL}
            onClick={() => {
              if (reset) {
                reset(forms.MANAGE_ORDER_FORM);
                reset(forms.TERMINATE_NUMBER_FORM);
              }
              manageAnotherOrder && manageAnotherOrder();
            }}
          >
            <FormattedMessage id="manage_order_manage_another_order" />
          </Button>
        </Flex>
      </>
    );
  },
  PAYMENT_BOX: ({
    isCreatingOrder,
    isFetchingPaymentRequest,
    order,
    paymentRequest,
    fetchPaymentRequest,
    token
  }) => {
    useEffect(() => {
      const order_ref = get(order, "order_ref");
      const payment_ref = get(paymentRequest, "order_ref");
      if (order_ref && order_ref !== payment_ref && !isFetchingPaymentRequest) {
        fetchPaymentRequest({ order_id: order_ref, token });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, paymentRequest, isFetchingPaymentRequest]);
    const payment = get(paymentRequest, "form_data", {});

    return <PaymentBox payment={payment} />;
  },
  UPDATE_PAYMENT_CARD: ({ originkey, token, data }) => {
    const [payment, setPayment] = useState({ origin: originkey, token });
    useEffect(
      () => {
        setPayment({ origin: originkey, token });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [originkey, token]
    );

    return (
      <>
        <PageHeader {...data} />
        <PaymentBox payment={payment} />
      </>
    );
  },
  SHOP_ORDER_SUMMARY: ({
    orderDetails,
    clearOrderDetails,
    fetchOrderDetails,
    type,
    txnId,
    data,
    mock,
    mockPaymentSuccess,
    mockPaymentFailure,
    mockPayment,
    isMockingPayment,
    clearMockPayment
  }) => {
    const orderParams = { type, order_ref: txnId };
    const payment = get(orderDetails, "payment", {});

    useEffect(
      () => {
        clearOrderDetails();
        clearMockPayment();
        fetchOrderDetails(orderParams);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    const mockPaymentProps = {
      mockPaymentSuccess,
      mockPaymentFailure,
      mockPayment,
      isMockingPayment,
      txnId
    };

    return (
      <>
        <PageHeader {...data} />
        {map(get(orderDetails, "items"), (item, index) => (
          <ProductItem key={index} {...item} />
        ))}
        {mock ? (
          <MockPaymentBox {...mockPaymentProps} />
        ) : (
          <PaymentBox payment={payment} />
        )}
      </>
    );
  },
  PAY_LATER_FORM: ({ data, order: { order_ref }, confirmPaymentOption }) => {
    const onSubmit = () => {
      console.log("onSubmit!");
      confirmPaymentOption(order_ref, () => {
        history.push(`${paths.PAYMENT_RETURN_V3}?order_ref=${order_ref}`);
      });
    };

    return <PayLaterForm {...data} onSubmit={onSubmit} />;
  },
  LEGACY_ADYEN_FORM: ({
    isCreatingOrder,
    isFetchingPaymentRequest,
    order,
    paymentRequest,
    fetchPaymentRequest,
    token
  }) => {
    const loading =
      isEmpty(order) ||
      isEmpty(paymentRequest) ||
      isCreatingOrder ||
      isFetchingPaymentRequest;
    useEffect(() => {
      const order_ref = get(order, "order_ref");
      if (order_ref && isEmpty(paymentRequest) && !isFetchingPaymentRequest) {
        fetchPaymentRequest({ order_id: order_ref, token });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, paymentRequest, isFetchingPaymentRequest]);
    const channel = getChannelFromUrl();
    const paymentReturnPath = paths.PAYMENT_RETURN.replace(":channel", channel);
    const orderSummaryPath = paths.ORDER_SUMMARY.replace(":channel", channel);
    const verifyPayment = (order, paymentRequest, paymentResponse) => {
      const orderRef = order.order_ref || paymentRequest.order_ref;
      const returnPath = `${paymentReturnPath}?order_ref=${orderRef}&token=${token}`;

      const payload = {
        payload: paymentResponse.payload,
        id: order.id,
        order_ref: orderRef
      };
      console.log("verifyPayment for order_ref", orderRef);

      if (!isEmpty(paymentRequest)) {
        axios
          .post(paymentRequest?.form_data?.verify_url, payload)
          .then(response => {
            console.log("verify payment response", response);

            if (paymentResponse.resultCode === "authorised") {
              setItem("checkDvsStatus", true);
              gotoUrl(returnPath, true, {}, true);
            } else {
              Alert.error("Payment unsuccessful please try again...");
              setTimeout(() => {
                gotoUrl(orderSummaryPath, true, {}, true);
              }, 3000);
            }
          });
      }
    };

    return (
      <>
        {loading ? (
          <Spinner size={200} sx={styles.modalContainer} />
        ) : (
          <Flex mb={4} p={2}>
            <LegacyAdyenForm
              paymentRequest={paymentRequest.form_data}
              onSuccess={paymentResponse => {
                console.log("success paymentResponse", paymentResponse);
                verifyPayment(order, paymentRequest, paymentResponse);
              }}
              onFail={paymentResponse => {
                console.log("failed paymentResponse", paymentResponse);
                verifyPayment(order, paymentRequest, paymentResponse);
              }}
            />
          </Flex>
        )}
      </>
    );
  },
  ADYEN_DROPIN: ({
    isCreatingOrder,
    isFetchingPaymentRequest,
    order,
    paymentRequest,
    fetchPaymentRequest,
    token
  }) => {
    const loading =
      isEmpty(order) ||
      isEmpty(paymentRequest) ||
      isCreatingOrder ||
      isFetchingPaymentRequest;
    const order_ref = get(order, "order_ref");
    useEffect(() => {
      if (order_ref && isEmpty(paymentRequest) && !isFetchingPaymentRequest) {
        fetchPaymentRequest({ order_id: order_ref, token });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, paymentRequest, isFetchingPaymentRequest]);
    const channel = getChannelFromUrl();
    const paymentReturnPath = paths.PAYMENT_RETURN.replace(":channel", channel);
    const orderSummaryPath = paths.ORDER_SUMMARY.replace(":channel", channel);
    const handlePaymentResponse = (paymentResponse, returnPath) => {
      const status = get(paymentResponse, "result.status");
      if (status === "SUCCESS") {
        setItem("checkDvsStatus", true);
        gotoUrl(returnPath, true, { order_ref, token }, true);
      } else {
        const error = get(paymentResponse, "result.error_message");
        Alert.error(
          `${status} - ${error} - Payment unsuccessful please try again...`
        );
        setTimeout(() => {
          gotoUrl(orderSummaryPath, true, {}, true);
        }, 3000);
      }
    };

    return (
      <Flex minHeight={"282px"} alignItems={"center"} justifyContent={"center"}>
        {loading ? (
          <Spinner size={200} sx={styles.modalContainer} />
        ) : (
          <AdyenDropin
            paymentRequestData={paymentRequest.form_data}
            returnUrl={paymentReturnPath}
            loading={loading}
            onSuccess={(paymentResponse, returnPath) => {
              console.log("success paymentResponse", paymentResponse);
              handlePaymentResponse(paymentResponse, returnPath);
            }}
            onFail={(paymentResponse, returnPath) => {
              console.log("failed paymentResponse", paymentResponse);
              handlePaymentResponse(paymentResponse, returnPath);
            }}
          />
        )}
      </Flex>
    );
  },
  SOCIAL_MEDIA_SIGNIN_OPTIONS: ({ generic, options, data }) => {
    const socialMediaOptions = get(generic, "social_media_signin_options", {});
    const supportSocialMediaOptions = [];
    options &&
      options.forEach(option => {
        if (socialMediaOptions[option.name]) {
          supportSocialMediaOptions.push({
            ...option,
            ...socialMediaOptions[option.name]
          });
        }
      });
    return <SocialMediaIcons options={supportSocialMediaOptions} data={data} />;
  },
  HR_WITH_TEXT: ({ label, styles = {} }) => {
    return (
      <Flex mt={24} sx={styles}>
        <Box width={1 / 2} mr={12} my="auto">
          <hr />
        </Box>
        <FormattedMessage id={label}>
          {text => <Text style={{ minWidth: "max-content" }}>{text}</Text>}
        </FormattedMessage>
        <Box width={1 / 2} ml={12} my="auto">
          <hr />
        </Box>
      </Flex>
    );
  },
  INLINE_PAGE_HEADERS: ({ headers }) => (
    <Flex>
      {headers.map(pageHeader => {
        const { enable = false, label, ...headerProps } = pageHeader;
        if (!enable) return null;

        return (
          <FormattedMessage key={label} id={label}>
            {greeting => (
              <H2 mb={[12, 24]} {...headerProps}>
                {greeting} &nbsp;
              </H2>
            )}
          </FormattedMessage>
        );
      })}{" "}
    </Flex>
  ),
  SUBMIT_BUTTON: props => {
    return <SubmitButton {...props} />;
  },
  OTP_BOXES: props => {
    return <OTPBoxes {...props} />;
  },
  OTP_EMAIL: props => {
    return <OTPEmail {...props} />;
  },
  OTP_EMAIL_BOXES: props => {
    return <EmailOTPBoxes {...props} />;
  },
  NAVIGATE_LINK: props => <NavigateLink {...props} />,
  PARAGRAPH: ({ content: id, styles = {}, data = {}, onEnter, ...props }) => {
    const { values: _values } = data;
    const values = {};

    if (!isEmpty(_values)) {
      _values.forEach(value => {
        values[value] = props[value];
      });
    }

    return (
      <P sx={styles} {...props}>
        <FormattedMessage id={id} values={values} html />
      </P>
    );
  },
  SIM_COUNT_SELECTOR: ({ data, change, formValues, ...props }) => {
    const { sim_count } = getURLParams();
    const { maxNumber, minNumber, fieldName } = data;
    useEffect(() => {
      let count;
      if (sim_count) {
        if (+sim_count >= maxNumber) {
          count = maxNumber;
        } else if (+sim_count <= 1) {
          count = minNumber;
        } else {
          count = +sim_count;
        }
      } else {
        count = minNumber;
      }

      handleChange(
        fieldName,
        get(props, "initialValues.sim_count")
          ? get(props, "initialValues.sim_count")
          : count
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (field, simCount) => {
      change(field, simCount);
    };

    return (
      <SIMCountSelector
        handleChange={handleChange}
        data={data}
        {...props}
        {...data}
        simCount={formValues[fieldName]}
      />
    );
  },
  ORDER_SUCCESS_VIEW: props => {
    let {
      style,
      pageProps,
      appSettings,
      screenshotEnabled,
      components: pageComponents,
      themeColors
    } = props;
    return (
      <>
        <div data-testid="smart-render">
          <Box
            style={{
              ...style,
              borderColor: get(themeColors, "card")
            }}
          >
            {isEmpty(pageComponents)
              ? null
              : renderPageComponents({
                  pageComponents,
                  pageProps,
                  appSettings,
                  screenshotEnabled
                })}
          </Box>
        </div>
      </>
    );
  },
  PAYMENT_FORM: ({
    isCreatingOrder,
    isFetchingPaymentRequest,
    order,
    paymentRequest,
    fetchPaymentRequest,
    clearPaymentRequest,
    token,
    appSettings,
    locale,
    formValues,
    canRequestPayment = true
  }) => {
    const loading =
      isEmpty(order) ||
      isEmpty(paymentRequest) ||
      isCreatingOrder ||
      isFetchingPaymentRequest;
    const order_ref = get(order, "order_ref");
    const channel = getChannelFromUrl();
    const orderSummaryPath = paths.ORDER_SUMMARY.replace(":channel", channel);

    const [showRetryPaymentMessage, setShowRetryPaymentMessage] = useState(
      false
    );
    const useStripePaymentForm =
      get(appSettings, "use_stripe_payment_form") || false;
    const enableOnetimePayment =
      get(appSettings, "enable_onetime_payment") || false;
    const pollPaymentStatusForSADOrder =
      get(appSettings, "poll_payment_status_for_sad_order") || false;
    const onetimePayment =
      enableOnetimePayment && get(formValues, "payment_type") === "onetime";
    const paymentReturnPath =
      channel === SELF_ACTIVATION_SIM &&
      !onetimePayment &&
      !pollPaymentStatusForSADOrder
        ? paths.SUCCESS.replace(":channel", channel)
        : paths.PAYMENT_RETURN.replace(":channel", channel);

    useEffect(() => {
      clearPaymentRequest();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onetimePayment]);

    useEffect(() => {
      if (
        !showRetryPaymentMessage &&
        canRequestPayment &&
        order_ref &&
        token &&
        isEmpty(paymentRequest) &&
        !isFetchingPaymentRequest
      ) {
        const return_url = `${window.location.origin}${paymentReturnPath}`;
        const failure_url = return_url;
        const cancel_url = `${window.location.origin}${orderSummaryPath}`;
        const paymentRequestParams = {
          order_id: order_ref,
          token,
          return_url,
          failure_url,
          cancel_url,
          onetime_payment: onetimePayment
        };
        setSessionToken(token);
        fetchPaymentRequest(paymentRequestParams, (response, error) => {
          if (isEmpty(response) || !!error) {
            setShowRetryPaymentMessage(true);
          }
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      token,
      isFetchingPaymentRequest,
      canRequestPayment,
      onetimePayment,
      showRetryPaymentMessage
    ]);
    const onPaymentSuccess = () => setItem("checkDvsStatus", true); // Used in AU. wont affect other countries

    const renderLegacyAdyenForm = () => {
      const verifyPayment = (order, paymentRequest, paymentResponse) => {
        const order_ref = order.order_ref || paymentRequest.order_ref;

        const payload = {
          payload: paymentResponse.payload,
          id: order.id,
          order_ref
        };
        console.log("verifyPayment for order_ref", order_ref);
        axios
          .post(paymentRequest.form_data.verify_url, payload)
          .then(response => {
            console.log("verify payment response", response);

            if (paymentResponse.resultCode === "authorised") {
              onPaymentSuccess();
              gotoUrl(paymentReturnPath, true, { order_ref, token }, true);
            } else {
              Alert.error("Payment unsuccessful please try again...");
              setTimeout(() => {
                gotoUrl(orderSummaryPath, true, {}, true);
              }, 3000);
            }
          });
      };

      return (
        <Flex mb={4} p={2}>
          <LegacyAdyenForm
            paymentRequest={paymentRequest.form_data}
            onSuccess={paymentResponse => {
              console.log("success paymentResponse", paymentResponse);
              verifyPayment(order, paymentRequest, paymentResponse);
            }}
            onFail={paymentResponse => {
              console.log("failed paymentResponse", paymentResponse);
              verifyPayment(order, paymentRequest, paymentResponse);
            }}
          />
        </Flex>
      );
    };

    const renderAdyenDropin = () => {
      const handlePaymentResponse = (paymentResponse, returnPath) => {
        const status = get(paymentResponse, "result.status");
        if (status === "SUCCESS") {
          onPaymentSuccess();
          gotoUrl(returnPath, true, { order_ref, token }, true);
        } else {
          const error = get(paymentResponse, "result.error_message");
          Alert.error(
            `${status} - ${error} - Payment unsuccessful please try again...`
          );
          setTimeout(() => {
            gotoUrl(orderSummaryPath, true, {}, true);
          }, 3000);
        }
      };
      return (
        <AdyenDropin
          paymentRequestData={paymentRequest.form_data}
          returnUrl={paymentReturnPath}
          loading={loading}
          onSuccess={(paymentResponse, returnPath) => {
            console.log("success paymentResponse", paymentResponse);
            handlePaymentResponse(paymentResponse, returnPath);
          }}
          onFail={(paymentResponse, returnPath) => {
            console.log("failed paymentResponse", paymentResponse);
            handlePaymentResponse(paymentResponse, returnPath);
          }}
        />
      );
    };

    const renderStripePayment = () => {
      const orderRef = order?.order_ref || paymentRequest?.order_ref;
      const returnPath = `${paymentReturnPath}?order_ref=${orderRef}&token=${token}`;
      return (
        <StripePaymentForm
          paymentRequest={paymentRequest}
          returnPath={returnPath}
          onPaymentSuccess={onPaymentSuccess}
          appSettings={appSettings}
        />
      );
    };

    const renderStripeCheckout = () => {
      const {
        stripe: {
          publishable_api_key,
          intent_confirmation,
          intent: { client_secret, amount }
        }
      } = get(paymentRequest, "form_data");
      const stripePromise = loadStripe(publishable_api_key);
      const orderRef = order.order_ref || paymentRequest.order_ref;
      const returnPath = `${paymentReturnPath}?order_ref=${orderRef}&token=${token}`;
      return (
        <Elements stripe={stripePromise}>
          <StripeCheckoutForm
            clientSecret={client_secret}
            intentConfirmation={intent_confirmation}
            amount={amount}
            successRedirectPath={returnPath}
            onPaymentSuccess={onPaymentSuccess}
          />
        </Elements>
      );
    };

    const renderWirecardForm = () => {
      return (
        <WirecardForm
          paymentRequest={paymentRequest}
          appSettings={appSettings}
          locale={locale}
          formValues={formValues}
        />
      );
    };

    const renderPaymentLink = label => {
      const url = get(paymentRequest, "form_data.action_object.url");
      return (
        <Box px={0} mb={10}>
          <Link rel="noopener noreferrer" href={url}>
            <Flex
              px={2}
              alignItems="center"
              width="100%"
              style={{
                backgroundColor: COLORS.blue[4],
                borderRadius: "25px",
                height: "48px",
                minWidth: "280px",
                color: "#ffffff",
                boxShadow: "0 2px 4px 0 rgb(0 0 0 / 23%)"
              }}
            >
              <Box mx={"auto"} p={"0.5rem"} pr={"0.5rem"}>
                <Text
                  fontWeight="bold"
                  fontSize={["1.2rem"]}
                  color={COLORS.white}
                >
                  <FormattedMessage id={label || "make_payment"} />
                </Text>
              </Box>
            </Flex>
          </Link>
        </Box>
      );
    };

    const renderSpinner = () => {
      return (
        <Box>
          <Spinner size={200} sx={styles.modalContainer} />
          {showRetryPaymentMessage && (
            <>
              <Text mt={3}>
                <FormattedMessage id="payment_loading_message" />
              </Text>
            </>
          )}
        </Box>
      );
    };

    const renderPaymentForm = () => {
      const { source, action, form_type, payment_session } =
        get(paymentRequest, "form_data") || {};

      if (form_type === "wirecard") {
        return renderWirecardForm();
      } else if (form_type === "stripe") {
        return useStripePaymentForm
          ? renderStripePayment()
          : renderStripeCheckout();
      } else if (form_type === "latitude") {
        return renderPaymentLink("latitude_url_title");
      } else if (source === "NPS" && action === "init_payment_form") {
        return renderAdyenDropin();
      } else if (payment_session) {
        return renderLegacyAdyenForm();
      } else {
        return renderSpinner();
      }
    };

    return (
      <Flex minHeight={"80px"} alignItems={"center"} justifyContent={"center"}>
        {loading ? renderSpinner() : renderPaymentForm()}
      </Flex>
    );
  },
  WALLET_FORM: props => <WalletForm {...props} />,
  PAYMENT_AMAZON_WIDGETS: ({ generic, styles, onSelectPaymentCard }) => (
    <AmazonWalletWidget
      generic={generic}
      styles={styles}
      onSelectPaymentCard={onSelectPaymentCard}
    />
  ),
  PHONE_LIST: props => <PhoneList {...props} />,
  PHONE_DETAILS: props => <PhoneDetails {...props} />,
  OUTSTANDING_INVOICE_CARD: props => <OutstandingInvoiceCard {...props} />,
  OUTSTANDING_PAYMENT_CARD: props => <OutstandingPaymentCard {...props} />,
  SIM_DETAILS_CARD: props => <SimDetailsCard {...props} />,
  CRITICAL_INFO_DETAILS_CARD: props => <CriticalInfoSummary {...props} />,
  ESIM_COMPATIBLE_LIST: props => <ESimCompatibleList {...props} />,
  ACCORDION: props => <Accordion {...props} />,
  PAYMENT_UPDATE_CARD_ADYEN_DROPIN: props => (
    <PaymentUpdateCardAdyenDropIn {...props} />
  ),
  PAYMENT_UPFRONT_ADYEN_DROPIN: props => (
    <PaymentUpfrontAdyenDropIn {...props} />
  ),
  CLOSE_ICON: props => {
    const {
      component: { items }
    } = props;

    return (
      <Flex
        pb={2}
        sx={{ cursor: "pointer" }}
        onClick={() =>
          safeEval(get, props.formValues, items.onClick, "", props)
        }
      >
        <Text pr={2}>X</Text>
        <FormattedMessage id="CLOSE" />
      </Flex>
    );
  },
  ...payments,
  RECEIVE_MY_PACKAGE: props => <CheckboxField {...props} />,
  AUTHORIZATION_FORM: props => {
    return featureMapping.PAGE_HEADER({
      ...props
    });
  },
  DATE_SLOT_SELECTION: ({
    availableDates,
    selectDate,
    formValues,
    data,
    themeColors,
    changeField,
    ...props
  }) => {
    const updateFormValues = selectedDateObject => {
      changeField("scheduled_date_full_data", selectedDateObject);
      changeField(
        get(props, "field", "scheduled_date"),
        get(selectedDateObject, "value")
      );
    };

    return (
      <DateSlotSelection
        {...props}
        {...data}
        formValues={formValues}
        items={availableDates}
        onSelect={selectDate}
        themeColors={themeColors}
        updateFormValues={updateFormValues}
        fieldKeyFullData="scheduled_date_full_data"
      />
    );
  },
  ORDER_AUTHORIZATION_CARD: props => (
    <OrderAuthorizationCard {...props} data-testid="order-authorization-card" />
  ),
  ...payments,
  PAYMENT_UPDATE_CARD_STRIPE_CHECKOUT: props => (
    <PaymentUpdateCardStripeCheckout {...props} />
  ),
  STRIPE_UPDATE_CARD_CHECKOUT: props => <StripeUpdateCard {...props} />,
  PAYMENT_UPFRONT_STRIPE_CHECKOUT: props => (
    <PaymentUpfrontStripeCheckout {...props} />
  ),
  PAYMENT_UPFRONT_FORM: props => <PaymentUpfrontForm {...props} />,
  PAYMENT_UPDATE_FORM: props => <PaymentUpdateForm {...props} />,
  MY_INFO_BOX: ({ data, ...props }) => {
    return <MyInfoBox {...props} {...data} />;
  },
  PAYMENT_CARD_DETAILS: props => <PaymentCardDetails {...props} />,
  TIMED_MESSAGE_BUTTON: props => <TimedMessageButton {...props} />,
  ERROR_MODAL: ({ data, ...props }) => (
    <ErrorModal data={data} {...props} data-testid="error-modal" />
  ),
};

const showComponent = ({
  renderProps,
  pageProps,
  sharedConfig,
  formValues
}) => {
  const enableComponent = get(renderProps, "enable", false);
  const allowComponent = safeEval(
    get,
    formValues,
    parseConditionVariables(
      get(pageProps, "appSettings.conditions"),
      get(renderProps, "condition_variable")
    ) || get(renderProps, "condition"),
    true,
    pageProps
  );
  const enabledInConfig = get(sharedConfig, "enable", true);
  return (enableComponent || enabledInConfig) && allowComponent;
};

const componentProps = ({
  renderProps,
  pageProps,
  sharedConfig,
  formValues,
  appSettings,
  normalize,
  screenshotEnabled,
  component
}) => {
  const required = get(
    sharedConfig,
    "required",
    get(renderProps, "required", false)
  );

  const disabled = safeEval(
    get,
    formValues,
    get(renderProps, "disabled"),
    false,
    renderProps
  );

  const labelSuffix = safeEval(
    get,
    formValues,
    get(renderProps, "label_suffix"),
    "",
    renderProps
  );

  let label = get(renderProps, "label");
  label =
    labelSuffix && isString(labelSuffix) ? `${label}_${labelSuffix}` : label;

  const placeholderSuffix = safeEval(
    get,
    formValues,
    get(renderProps, "placeholder_suffix"),
    "",
    renderProps
  );

  let placeholder = get(renderProps, "placeholder");
  placeholder =
    placeholderSuffix && isString(placeholderSuffix)
      ? `${placeholder}_${placeholderSuffix}`
      : placeholder;

  return {
    ...appSettings,
    ...renderProps,
    ...pageProps,
    normalize,
    label,
    placeholder,
    required,
    disabled,
    screenshotEnabled,
    component,
    pageProps
  };
};

const renderSmartComponent = ({
  renderProps,
  pageProps,
  appSettings,
  normalize,
  screenshotEnabled,
  RenderComponent,
  component
}) => {
  const formValues = get(pageProps, "formValues", {});
  const lookup = get(renderProps, "lookup");
  const sharedConfig = get(appSettings, lookup);

  return showComponent({ renderProps, pageProps, sharedConfig, formValues }) ? (
    <RenderComponent
      {...componentProps({
        renderProps,
        pageProps,
        sharedConfig,
        formValues,
        appSettings,
        normalize,
        screenshotEnabled,
        component
      })}
    />
  ) : null;
};

const renderPageBanner = ({ pageBanner, pageProps }) => {
  if (isEmpty(pageBanner)) return null;
  const data = {
    boxVariant: "banner",
    alt: "pageBanner",
    ...pageBanner
  };
  return featureMapping["IMAGE"]({ data, ...pageProps });
};

const renderPageStepper = ({ pageStepper, padding }) => {
  if (isEmpty(pageStepper)) return null;
  const mt = pageStepper.marginTop || 0;
  const mb = pageStepper.marginBottom || 0;
  const pad = pageStepper.padding || padding;
  return (
    <Box variant="main" padding={pad} mb={mb} mt={mt}>
      {featureMapping["STEPPER"]({ ...pageStepper, standalone: true })}
    </Box>
  );
};

const renderPageFaqs = ({ pageFaqs = {}, messageData = {}, themeColors }) => (
  <PageFaqs {...pageFaqs} messageData={messageData} themeColors={themeColors} />
);

const entRenderPageFaqs = ({ entPageFaqs = {}, messageData = {}, themeColors }) => (
  <EntFAQ {...entPageFaqs} messageData={messageData} themeColors={themeColors} />
);

export const renderPageComponents = ({
  pageComponents,
  pageProps,
  appSettings,
  screenshotEnabled
}) => {
  const FLEX_START = "FLEX_START";
  const FLEX_END = "FLEX_END";
  // Merge reusable components and page specific private components
  const allComponents = { ...featureMapping, ...pageProps.privateComponents };
  // Flex box wrapping related variables
  let flexStarted = false,
    flexEndReached = false,
    flexWrappedComponents = [],
    flexProps = {},
    eachItemProps = {};

  return map(pageComponents, (component, index) => {
    const { name, width } = component;
    // Checks if components should be wrapped inside a flex container
    if (name === FLEX_START) {
      flexStarted = true;
      flexProps = get(component, "data", {});
      eachItemProps = get(component, "eachItem", {});
      return null;
    }

    // Checks for the Flex container end component.
    if (name === FLEX_END) {
      flexStarted = false;
      flexEndReached = true;
    }

    const RenderComponent = allComponents[name];
    if (!RenderComponent && !flexEndReached) return null;
    const normalize = normalizers(component, appSettings);

    const FeatureToggledComponent = (
      <FeatureToggle
        appSettings={appSettings}
        component={component}
        key={`${name}-${index}`}
        width={width}
        render={renderProps =>
          renderSmartComponent({
            renderProps,
            pageProps,
            appSettings,
            normalize,
            screenshotEnabled,
            RenderComponent,
            component
          })
        }
      />
    );

    /**
     * If Flex wraping started all components are stored in an array.
     * This array then will be used to return the components wrappped in a flex box
     */
    if (flexStarted) {
      flexWrappedComponents.push(FeatureToggledComponent);
      return null;
    }

    /**
     * Once the flex end is reached all the components defined will be wrapped under flex box
     */
    if (flexEndReached) {
      // Need to set it to false to indicate the flex end is treated
      flexEndReached = false;
      return (
        <Flex
          key="flex-start-box"
          {...flexProps}
          data-testid="flex-start-box-id"
        >
          {flexWrappedComponents.map((flexWrapComponent, index) => (
            <Box key={index} {...eachItemProps}>
              {flexWrapComponent}
            </Box>
          ))}
        </Flex>
      );
    }

    return FeatureToggledComponent;
  });
};

const SmartRender = pageProps => {
  const {
    workflow,
    appSettings,
    messageData,
    match,
    themeColors,
    hideComponentsWithDeviceChecker,
    enableSimCountNextBtn
  } = pageProps;
  useEffect(() => {
    const channel = getChannelFromUrl();
    const channelWorkflow = find(workflow, ({ path }) =>
      path.match(`/${channel}`)
    );
    const landingPage = get(channelWorkflow, "path");
    isWorkflowChannel() ? setLandingPage(landingPage) : resetLandingPage();

    const additionalStandalonePaths = appSettings?.standalone_paths || [];
    const additionalStandaloneRoutes = appSettings?.standalone_routes || [];
    const standalonePaths = [
      ...STANDALONE_WORKFLOW_PATHS,
      ...additionalStandalonePaths
    ];
    const standaloneRoutes = [
      ...STANDALONE_WORKFLOW_ROUTES,
      ...additionalStandaloneRoutes
    ];
    const isStandalonePage =
      includes(standalonePaths, window.location.pathname) ||
      includes(standaloneRoutes, match?.path);

    // setLandingPageVisited true for standalone page
    if (window.location.pathname === landingPage || isStandalonePage) {
      setLandingPageVisited(true);
    }
    if (window.location.pathname === paths.LANDING_PAGE) {
      const landingPagePath = get(workflow, "0.path", "");
      if (landingPagePath && window.location.pathname !== landingPagePath) {
        Session.getDeviceId();
        gotoUrl(landingPagePath, true, { reset: undefined });
      }
    } else {
      if (
        isWorkflowChannel() &&
        !getLandingPageVisited() &&
        !isStandalonePage &&
        !IS_PATHS_SECURED // disable landing page visited as login will manage workflow
      ) {
        gotoUrl(getLandingPage(), true, { reset: undefined });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflow, appSettings, match]);

  const channel = getChannelFromUrl();
  const urlParts = get(window, "location.pathname", "").split("/");
  const firstUrlPart = urlParts.length > 1 ? urlParts[2] : "web";
  let currentWorkflowPage;
  if (channel === PARTNERS_CHANNEL && firstUrlPart !== "success") {
    currentWorkflowPage = find(
      workflow,
      page => page.path === "/partners/:partnerID"
    );
  } else {
    currentWorkflowPage = find(
      workflow,
      page => page.path === window.location.pathname
    );
  }
  const maintenanceRedirectPage = get(appSettings, [
    "maintenanceRedirectPages",
    window.location.pathname
  ]);

  if (appSettings?.maintenanceMode) {
    gotoUrl(
      maintenanceRedirectPage ||
        appSettings?.maintenancePage ||
        paths.MAINTENANCE
    );
  }

  if (handleMaintenanceBanner(appSettings)) {
    gotoUrl(
      maintenanceRedirectPage ||
        paths.MAINTENANCE
    );
  }

  const redirectPage =
    get(currentWorkflowPage, "redirect") || maintenanceRedirectPage;
  if (redirectPage) {
    gotoUrl(redirectPage);
  }
  const pageComponents = get(currentWorkflowPage, "components");
  const pageBanner = get(currentWorkflowPage, "banner");
  const pageStepper = get(currentWorkflowPage, "stepper");
  const pageFaqs = get(currentWorkflowPage, "faqs");
  const themeVariant = get(currentWorkflowPage, "themeVariant", "main");
  const padding = get(currentWorkflowPage, "padding", [6, 8]);
  const screenshotEnabled = get(currentWorkflowPage, "screenshot", false);
  const flexMode = get(currentWorkflowPage, "flex", true);
  // Putting a validation saying the path will be available if the previous path is from one of the mentioned in allowedPrevPaths
  const allowedPrevPaths = get(currentWorkflowPage, "allowedPrevPaths");
  const entPageFaqs = get(currentWorkflowPage, "entFaqs");
  if (allowedPrevPaths) {
    const prevPath = window.location?.pathTracking?.previous;
    const currentPath = window.location?.pathTracking?.current;

    // if previous path is not in allowed paths take the user back to previous path
    // prevPath !== currentPath to allow reloads from same page
    if (prevPath !== currentPath && allowedPrevPaths.indexOf(prevPath) === -1) {
      return history.push(prevPath);
    }
  }

  const containerProps = {
    variant: themeVariant,
    padding: padding
  };

  const flexProps = !flexMode
    ? {}
    : {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between"
      };
  return (
    <div data-testid="smart-render">
      {renderPageBanner({ pageBanner, pageProps })}
      {renderPageStepper({ pageStepper, padding })}
      <Box {...containerProps} {...flexProps}>
        {isEmpty(pageComponents) ? (
          <Spinner size={200} sx={styles.fullPage} />
        ) : (
          renderPageComponents({
            pageComponents,
            pageProps,
            appSettings,
            screenshotEnabled
          })
        )}
      </Box>
      {!hideComponentsWithDeviceChecker &&
        renderPageFaqs({ pageFaqs, messageData, themeColors })}
      {entPageFaqs && enableSimCountNextBtn ? entRenderPageFaqs({ entPageFaqs, messageData, themeColors }) : null}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  workflow: makeSelectWorkflow(),
  appSettings: makeSelectAppSettings(),
  currencyFormat: makeSelectCurrencyFormat(),
  webview: isWebview,
  isWebview: isWebview,
  isNative: isNative,
  isMobile: isMobile,
  planName: makeSelectPlanName(),
  planTextName: makeSelectPlanTextName(),
  payTodayItems: makeSelectPayTodayItems(),
  payMonthlyItems: makeSelectPayMonthlyItems(),
  phoneVariant: makeSelectPhoneVariant(),
  phonePaymentOption: makeSelectPhonePaymentOption(),
  userDetails: makeSelectUserDetails(),
  isFetchingAnyData: makeSelectIsFetchingAnyData(),
  themeColors: makeSelectThemeColors(),
  channelPhonePaymentOptions: makeSelectChannelPhonePaymentOptions(),
  enableSimCountNextBtn: makeSelectEnableSimCountNextButton()
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onSubmit: (navigate, payload, onSubmitOverride, data) => {
    const combinedProps = {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      onSubmitOverride
    };
    const onSubmitActionHandler = getOnSubmitActionHandler(combinedProps);
    isFunction(onSubmitActionHandler)
      ? onSubmitActionHandler(navigate, payload, data)
      : isFunction(combinedProps.onSubmit)
      ? combinedProps.onSubmit(navigate, payload)
      : navigate();
  }
});

const withConnect = connect(mapStateToProps, mergeProps);
export default compose(withConnect, memo)(SmartRender);
